/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Postifoto API
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import { apiFetch } from '../fetcher';
const withQueryKey = (query, queryKey) => {
    const result = { queryKey };
    for (const key of Object.keys(query)) {
        // The explicit queryKey always wins, matching the previous
        // `{ ...query, queryKey }` spread where it was set last.
        if (key === 'queryKey')
            continue;
        Object.defineProperty(result, key, {
            enumerable: true,
            configurable: true,
            get: () => query[key],
        });
    }
    return result;
};
export const getGetHealthLiveUrl = () => {
    return `/api/v1/health/live`;
};
/**
 * @summary Liveness: процесс жив
 */
export const getHealthLive = async (options) => {
    return apiFetch(getGetHealthLiveUrl(), {
        ...options,
        method: 'GET'
    });
};
export const getGetHealthLiveQueryKey = () => {
    return [
        `/api/v1/health/live`
    ];
};
export const getGetHealthLiveQueryOptions = (options) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetHealthLiveQueryKey();
    const queryFn = ({ signal }) => getHealthLive({ signal, ...requestOptions });
    return { queryKey, queryFn, ...queryOptions };
};
/**
 * @summary Liveness: процесс жив
 */
export function useGetHealthLive(options, queryClient) {
    const queryOptions = getGetHealthLiveQueryOptions(options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetHealthReadyUrl = () => {
    return `/api/v1/health/ready`;
};
/**
 * @summary Readiness: доступность PostgreSQL, Valkey и S3, версии
 */
export const getHealthReady = async (options) => {
    return apiFetch(getGetHealthReadyUrl(), {
        ...options,
        method: 'GET'
    });
};
export const getGetHealthReadyQueryKey = () => {
    return [
        `/api/v1/health/ready`
    ];
};
export const getGetHealthReadyQueryOptions = (options) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetHealthReadyQueryKey();
    const queryFn = ({ signal }) => getHealthReady({ signal, ...requestOptions });
    return { queryKey, queryFn, ...queryOptions };
};
/**
 * @summary Readiness: доступность PostgreSQL, Valkey и S3, версии
 */
export function useGetHealthReady(options, queryClient) {
    const queryOptions = getGetHealthReadyQueryOptions(options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetInstanceInfoUrl = () => {
    return `/api/v1/public/instance`;
};
/**
 * @summary Публичные сведения об инстансе (бренд, языки, версия)
 */
export const getInstanceInfo = async (options) => {
    return apiFetch(getGetInstanceInfoUrl(), {
        ...options,
        method: 'GET'
    });
};
export const getGetInstanceInfoQueryKey = () => {
    return [
        `/api/v1/public/instance`
    ];
};
export const getGetInstanceInfoQueryOptions = (options) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetInstanceInfoQueryKey();
    const queryFn = ({ signal }) => getInstanceInfo({ signal, ...requestOptions });
    return { queryKey, queryFn, ...queryOptions };
};
/**
 * @summary Публичные сведения об инстансе (бренд, языки, версия)
 */
export function useGetInstanceInfo(options, queryClient) {
    const queryOptions = getGetInstanceInfoQueryOptions(options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getReportClientErrorUrl = () => {
    return `/api/v1/staff/client-errors`;
};
/**
 * @summary Ошибка интерфейса backoffice — в журнал ошибок (без персональных данных)
 */
export const reportClientError = async (clientErrorReport, options) => {
    const getHeaders = (h) => {
        if (!h)
            return {};
        if (h instanceof Headers)
            return Object.fromEntries(h.entries());
        if (Symbol.iterator in h) {
            return Object.fromEntries(Array.from(h, (entry) => Array.from(entry)));
        }
        const headers = {};
        for (const [name, value] of Object.entries(h)) {
            if (value !== undefined)
                headers[name] = value;
        }
        return headers;
    };
    return apiFetch(getReportClientErrorUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
        body: JSON.stringify(clientErrorReport)
    });
};
export const getReportClientErrorMutationKey = () => ['reportClientError'];
export const getReportClientErrorMutationOptions = (options) => {
    const mutationKey = getReportClientErrorMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options ?
        options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
            options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey, }, request: undefined };
    const mutationFn = (props) => {
        const { data } = props ?? {};
        return reportClientError(data, requestOptions);
    };
    return { mutationFn, ...mutationOptions };
};
/**
* @summary Ошибка интерфейса backoffice — в журнал ошибок (без персональных данных)
*/
export const useReportClientError = (options, queryClient) => {
    return useMutation(getReportClientErrorMutationOptions(options), queryClient);
};
export const getCreateSystemCheckUrl = () => {
    return `/api/v1/staff/system/checks`;
};
/**
 * @summary Запустить проверку очереди (демо сквозного пути)
 */
export const createSystemCheck = async (options) => {
    return apiFetch(getCreateSystemCheckUrl(), {
        ...options,
        method: 'POST'
    });
};
export const getCreateSystemCheckMutationKey = () => ['createSystemCheck'];
export const getCreateSystemCheckMutationOptions = (options) => {
    const mutationKey = getCreateSystemCheckMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options ?
        options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
            options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey, }, request: undefined };
    const mutationFn = () => {
        return createSystemCheck(requestOptions);
    };
    return { mutationFn, ...mutationOptions };
};
/**
* @summary Запустить проверку очереди (демо сквозного пути)
*/
export const useCreateSystemCheck = (options, queryClient) => {
    return useMutation(getCreateSystemCheckMutationOptions(options), queryClient);
};
export const getGetSystemCheckUrl = (id) => {
    return `/api/v1/staff/system/checks/${id}`;
};
/**
 * @summary Состояние проверки очереди
 */
export const getSystemCheck = async (id, options) => {
    return apiFetch(getGetSystemCheckUrl(id), {
        ...options,
        method: 'GET'
    });
};
export const getGetSystemCheckQueryKey = (id) => {
    return [
        `/api/v1/staff/system/checks/${id}`
    ];
};
export const getGetSystemCheckQueryOptions = (id, options) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetSystemCheckQueryKey(id);
    const queryFn = ({ signal }) => getSystemCheck(id, { signal, ...requestOptions });
    return { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions };
};
/**
 * @summary Состояние проверки очереди
 */
export function useGetSystemCheck(id, options, queryClient) {
    const queryOptions = getGetSystemCheckQueryOptions(id, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetBackupStatusUrl = () => {
    return `/api/v1/staff/system/backups`;
};
/**
 * @summary Состояние бэкапов: база, архив WAL, файлы, найденные проблемы
 */
export const getBackupStatus = async (options) => {
    return apiFetch(getGetBackupStatusUrl(), {
        ...options,
        method: 'GET'
    });
};
export const getGetBackupStatusQueryKey = () => {
    return [
        `/api/v1/staff/system/backups`
    ];
};
export const getGetBackupStatusQueryOptions = (options) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetBackupStatusQueryKey();
    const queryFn = ({ signal }) => getBackupStatus({ signal, ...requestOptions });
    return { queryKey, queryFn, ...queryOptions };
};
/**
 * @summary Состояние бэкапов: база, архив WAL, файлы, найденные проблемы
 */
export function useGetBackupStatus(options, queryClient) {
    const queryOptions = getGetBackupStatusQueryOptions(options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getLoginStaffUrl = () => {
    return `/api/v1/staff/auth/login`;
};
/**
 * @summary Вход сотрудника: e-mail и пароль
 */
export const loginStaff = async (staffLoginRequest, options) => {
    const getHeaders = (h) => {
        if (!h)
            return {};
        if (h instanceof Headers)
            return Object.fromEntries(h.entries());
        if (Symbol.iterator in h) {
            return Object.fromEntries(Array.from(h, (entry) => Array.from(entry)));
        }
        const headers = {};
        for (const [name, value] of Object.entries(h)) {
            if (value !== undefined)
                headers[name] = value;
        }
        return headers;
    };
    return apiFetch(getLoginStaffUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
        body: JSON.stringify(staffLoginRequest)
    });
};
export const getLoginStaffMutationKey = () => ['loginStaff'];
export const getLoginStaffMutationOptions = (options) => {
    const mutationKey = getLoginStaffMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options ?
        options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
            options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey, }, request: undefined };
    const mutationFn = (props) => {
        const { data } = props ?? {};
        return loginStaff(data, requestOptions);
    };
    return { mutationFn, ...mutationOptions };
};
/**
* @summary Вход сотрудника: e-mail и пароль
*/
export const useLoginStaff = (options, queryClient) => {
    return useMutation(getLoginStaffMutationOptions(options), queryClient);
};
export const getVerifyStaffTotpUrl = () => {
    return `/api/v1/staff/auth/totp`;
};
/**
 * @summary Второй фактор: код из письма, из приложения или код восстановления
 */
export const verifyStaffTotp = async (staffTotpRequest, options) => {
    const getHeaders = (h) => {
        if (!h)
            return {};
        if (h instanceof Headers)
            return Object.fromEntries(h.entries());
        if (Symbol.iterator in h) {
            return Object.fromEntries(Array.from(h, (entry) => Array.from(entry)));
        }
        const headers = {};
        for (const [name, value] of Object.entries(h)) {
            if (value !== undefined)
                headers[name] = value;
        }
        return headers;
    };
    return apiFetch(getVerifyStaffTotpUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
        body: JSON.stringify(staffTotpRequest)
    });
};
export const getVerifyStaffTotpMutationKey = () => ['verifyStaffTotp'];
export const getVerifyStaffTotpMutationOptions = (options) => {
    const mutationKey = getVerifyStaffTotpMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options ?
        options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
            options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey, }, request: undefined };
    const mutationFn = (props) => {
        const { data } = props ?? {};
        return verifyStaffTotp(data, requestOptions);
    };
    return { mutationFn, ...mutationOptions };
};
/**
* @summary Второй фактор: код из письма, из приложения или код восстановления
*/
export const useVerifyStaffTotp = (options, queryClient) => {
    return useMutation(getVerifyStaffTotpMutationOptions(options), queryClient);
};
export const getSendStaffEmailCodeUrl = () => {
    return `/api/v1/staff/auth/email-code`;
};
/**
 * @summary Отправить код подтверждения на e-mail: вход или step-up (ADR-067)
 */
export const sendStaffEmailCode = async (options) => {
    return apiFetch(getSendStaffEmailCodeUrl(), {
        ...options,
        method: 'POST'
    });
};
export const getSendStaffEmailCodeMutationKey = () => ['sendStaffEmailCode'];
export const getSendStaffEmailCodeMutationOptions = (options) => {
    const mutationKey = getSendStaffEmailCodeMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options ?
        options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
            options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey, }, request: undefined };
    const mutationFn = () => {
        return sendStaffEmailCode(requestOptions);
    };
    return { mutationFn, ...mutationOptions };
};
/**
* @summary Отправить код подтверждения на e-mail: вход или step-up (ADR-067)
*/
export const useSendStaffEmailCode = (options, queryClient) => {
    return useMutation(getSendStaffEmailCodeMutationOptions(options), queryClient);
};
export const getInspectStaffSetupUrl = () => {
    return `/api/v1/staff/auth/setup/inspect`;
};
/**
 * @summary Проверить ссылку настройки (токен — в теле, не в URL)
 */
export const inspectStaffSetup = async (setupTokenRequest, options) => {
    const getHeaders = (h) => {
        if (!h)
            return {};
        if (h instanceof Headers)
            return Object.fromEntries(h.entries());
        if (Symbol.iterator in h) {
            return Object.fromEntries(Array.from(h, (entry) => Array.from(entry)));
        }
        const headers = {};
        for (const [name, value] of Object.entries(h)) {
            if (value !== undefined)
                headers[name] = value;
        }
        return headers;
    };
    return apiFetch(getInspectStaffSetupUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
        body: JSON.stringify(setupTokenRequest)
    });
};
export const getInspectStaffSetupMutationKey = () => ['inspectStaffSetup'];
export const getInspectStaffSetupMutationOptions = (options) => {
    const mutationKey = getInspectStaffSetupMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options ?
        options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
            options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey, }, request: undefined };
    const mutationFn = (props) => {
        const { data } = props ?? {};
        return inspectStaffSetup(data, requestOptions);
    };
    return { mutationFn, ...mutationOptions };
};
/**
* @summary Проверить ссылку настройки (токен — в теле, не в URL)
*/
export const useInspectStaffSetup = (options, queryClient) => {
    return useMutation(getInspectStaffSetupMutationOptions(options), queryClient);
};
export const getCompleteStaffSetupUrl = () => {
    return `/api/v1/staff/auth/setup`;
};
/**
 * @summary Задать пароль по ссылке настройки
 */
export const completeStaffSetup = async (completeSetupRequest, options) => {
    const getHeaders = (h) => {
        if (!h)
            return {};
        if (h instanceof Headers)
            return Object.fromEntries(h.entries());
        if (Symbol.iterator in h) {
            return Object.fromEntries(Array.from(h, (entry) => Array.from(entry)));
        }
        const headers = {};
        for (const [name, value] of Object.entries(h)) {
            if (value !== undefined)
                headers[name] = value;
        }
        return headers;
    };
    return apiFetch(getCompleteStaffSetupUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
        body: JSON.stringify(completeSetupRequest)
    });
};
export const getCompleteStaffSetupMutationKey = () => ['completeStaffSetup'];
export const getCompleteStaffSetupMutationOptions = (options) => {
    const mutationKey = getCompleteStaffSetupMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options ?
        options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
            options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey, }, request: undefined };
    const mutationFn = (props) => {
        const { data } = props ?? {};
        return completeStaffSetup(data, requestOptions);
    };
    return { mutationFn, ...mutationOptions };
};
/**
* @summary Задать пароль по ссылке настройки
*/
export const useCompleteStaffSetup = (options, queryClient) => {
    return useMutation(getCompleteStaffSetupMutationOptions(options), queryClient);
};
export const getStartTotpEnrollmentUrl = () => {
    return `/api/v1/staff/auth/totp/enroll/start`;
};
/**
 * @summary Начать подключение приложения-аутентификатора
 */
export const startTotpEnrollment = async (options) => {
    return apiFetch(getStartTotpEnrollmentUrl(), {
        ...options,
        method: 'POST'
    });
};
export const getStartTotpEnrollmentMutationKey = () => ['startTotpEnrollment'];
export const getStartTotpEnrollmentMutationOptions = (options) => {
    const mutationKey = getStartTotpEnrollmentMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options ?
        options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
            options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey, }, request: undefined };
    const mutationFn = () => {
        return startTotpEnrollment(requestOptions);
    };
    return { mutationFn, ...mutationOptions };
};
/**
* @summary Начать подключение приложения-аутентификатора
*/
export const useStartTotpEnrollment = (options, queryClient) => {
    return useMutation(getStartTotpEnrollmentMutationOptions(options), queryClient);
};
export const getConfirmTotpEnrollmentUrl = () => {
    return `/api/v1/staff/auth/totp/enroll/confirm`;
};
/**
 * @summary Подтвердить подключение кодом из приложения
 */
export const confirmTotpEnrollment = async (confirmTotpRequest, options) => {
    const getHeaders = (h) => {
        if (!h)
            return {};
        if (h instanceof Headers)
            return Object.fromEntries(h.entries());
        if (Symbol.iterator in h) {
            return Object.fromEntries(Array.from(h, (entry) => Array.from(entry)));
        }
        const headers = {};
        for (const [name, value] of Object.entries(h)) {
            if (value !== undefined)
                headers[name] = value;
        }
        return headers;
    };
    return apiFetch(getConfirmTotpEnrollmentUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
        body: JSON.stringify(confirmTotpRequest)
    });
};
export const getConfirmTotpEnrollmentMutationKey = () => ['confirmTotpEnrollment'];
export const getConfirmTotpEnrollmentMutationOptions = (options) => {
    const mutationKey = getConfirmTotpEnrollmentMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options ?
        options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
            options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey, }, request: undefined };
    const mutationFn = (props) => {
        const { data } = props ?? {};
        return confirmTotpEnrollment(data, requestOptions);
    };
    return { mutationFn, ...mutationOptions };
};
/**
* @summary Подтвердить подключение кодом из приложения
*/
export const useConfirmTotpEnrollment = (options, queryClient) => {
    return useMutation(getConfirmTotpEnrollmentMutationOptions(options), queryClient);
};
export const getLogoutStaffUrl = () => {
    return `/api/v1/staff/auth/logout`;
};
/**
 * @summary Выход
 */
export const logoutStaff = async (options) => {
    return apiFetch(getLogoutStaffUrl(), {
        ...options,
        method: 'POST'
    });
};
export const getLogoutStaffMutationKey = () => ['logoutStaff'];
export const getLogoutStaffMutationOptions = (options) => {
    const mutationKey = getLogoutStaffMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options ?
        options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
            options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey, }, request: undefined };
    const mutationFn = () => {
        return logoutStaff(requestOptions);
    };
    return { mutationFn, ...mutationOptions };
};
/**
* @summary Выход
*/
export const useLogoutStaff = (options, queryClient) => {
    return useMutation(getLogoutStaffMutationOptions(options), queryClient);
};
export const getStepUpStaffUrl = () => {
    return `/api/v1/staff/me/step-up`;
};
/**
 * @summary Подтвердить себя кодом перед опасным действием (step-up)
 */
export const stepUpStaff = async (staffTotpRequest, options) => {
    const getHeaders = (h) => {
        if (!h)
            return {};
        if (h instanceof Headers)
            return Object.fromEntries(h.entries());
        if (Symbol.iterator in h) {
            return Object.fromEntries(Array.from(h, (entry) => Array.from(entry)));
        }
        const headers = {};
        for (const [name, value] of Object.entries(h)) {
            if (value !== undefined)
                headers[name] = value;
        }
        return headers;
    };
    return apiFetch(getStepUpStaffUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
        body: JSON.stringify(staffTotpRequest)
    });
};
export const getStepUpStaffMutationKey = () => ['stepUpStaff'];
export const getStepUpStaffMutationOptions = (options) => {
    const mutationKey = getStepUpStaffMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options ?
        options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
            options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey, }, request: undefined };
    const mutationFn = (props) => {
        const { data } = props ?? {};
        return stepUpStaff(data, requestOptions);
    };
    return { mutationFn, ...mutationOptions };
};
/**
* @summary Подтвердить себя кодом перед опасным действием (step-up)
*/
export const useStepUpStaff = (options, queryClient) => {
    return useMutation(getStepUpStaffMutationOptions(options), queryClient);
};
export const getChangeMyPasswordUrl = () => {
    return `/api/v1/staff/me/password`;
};
/**
 * @summary Сменить свой пароль (остальные сессии завершаются)
 */
export const changeMyPassword = async (changePasswordRequest, options) => {
    const getHeaders = (h) => {
        if (!h)
            return {};
        if (h instanceof Headers)
            return Object.fromEntries(h.entries());
        if (Symbol.iterator in h) {
            return Object.fromEntries(Array.from(h, (entry) => Array.from(entry)));
        }
        const headers = {};
        for (const [name, value] of Object.entries(h)) {
            if (value !== undefined)
                headers[name] = value;
        }
        return headers;
    };
    return apiFetch(getChangeMyPasswordUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
        body: JSON.stringify(changePasswordRequest)
    });
};
export const getChangeMyPasswordMutationKey = () => ['changeMyPassword'];
export const getChangeMyPasswordMutationOptions = (options) => {
    const mutationKey = getChangeMyPasswordMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options ?
        options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
            options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey, }, request: undefined };
    const mutationFn = (props) => {
        const { data } = props ?? {};
        return changeMyPassword(data, requestOptions);
    };
    return { mutationFn, ...mutationOptions };
};
/**
* @summary Сменить свой пароль (остальные сессии завершаются)
*/
export const useChangeMyPassword = (options, queryClient) => {
    return useMutation(getChangeMyPasswordMutationOptions(options), queryClient);
};
export const getListMySessionsUrl = () => {
    return `/api/v1/staff/me/sessions`;
};
/**
 * @summary Свои действующие сессии: устройство, IP, время входа и последней активности
 */
export const listMySessions = async (options) => {
    return apiFetch(getListMySessionsUrl(), {
        ...options,
        method: 'GET'
    });
};
export const getListMySessionsQueryKey = () => {
    return [
        `/api/v1/staff/me/sessions`
    ];
};
export const getListMySessionsQueryOptions = (options) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getListMySessionsQueryKey();
    const queryFn = ({ signal }) => listMySessions({ signal, ...requestOptions });
    return { queryKey, queryFn, ...queryOptions };
};
/**
 * @summary Свои действующие сессии: устройство, IP, время входа и последней активности
 */
export function useListMySessions(options, queryClient) {
    const queryOptions = getListMySessionsQueryOptions(options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getRevokeMySessionUrl = (sessionId) => {
    return `/api/v1/staff/me/sessions/${sessionId}`;
};
/**
 * @summary Завершить свою сессию на другом устройстве
 */
export const revokeMySession = async (sessionId, options) => {
    return apiFetch(getRevokeMySessionUrl(sessionId), {
        ...options,
        method: 'DELETE'
    });
};
export const getRevokeMySessionMutationKey = () => ['revokeMySession'];
export const getRevokeMySessionMutationOptions = (options) => {
    const mutationKey = getRevokeMySessionMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options ?
        options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
            options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey, }, request: undefined };
    const mutationFn = (props) => {
        const { sessionId } = props ?? {};
        return revokeMySession(sessionId, requestOptions);
    };
    return { mutationFn, ...mutationOptions };
};
/**
* @summary Завершить свою сессию на другом устройстве
*/
export const useRevokeMySession = (options, queryClient) => {
    return useMutation(getRevokeMySessionMutationOptions(options), queryClient);
};
export const getRevokeMyOtherSessionsUrl = () => {
    return `/api/v1/staff/me/sessions/revoke-others`;
};
/**
 * @summary Завершить все свои сессии, кроме текущей
 */
export const revokeMyOtherSessions = async (options) => {
    return apiFetch(getRevokeMyOtherSessionsUrl(), {
        ...options,
        method: 'POST'
    });
};
export const getRevokeMyOtherSessionsMutationKey = () => ['revokeMyOtherSessions'];
export const getRevokeMyOtherSessionsMutationOptions = (options) => {
    const mutationKey = getRevokeMyOtherSessionsMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options ?
        options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
            options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey, }, request: undefined };
    const mutationFn = () => {
        return revokeMyOtherSessions(requestOptions);
    };
    return { mutationFn, ...mutationOptions };
};
/**
* @summary Завершить все свои сессии, кроме текущей
*/
export const useRevokeMyOtherSessions = (options, queryClient) => {
    return useMutation(getRevokeMyOtherSessionsMutationOptions(options), queryClient);
};
export const getRegenerateRecoveryCodesUrl = () => {
    return `/api/v1/staff/me/recovery-codes`;
};
/**
 * @summary Выпустить новые коды восстановления (старые перестают действовать)
 */
export const regenerateRecoveryCodes = async (staffTotpRequest, options) => {
    const getHeaders = (h) => {
        if (!h)
            return {};
        if (h instanceof Headers)
            return Object.fromEntries(h.entries());
        if (Symbol.iterator in h) {
            return Object.fromEntries(Array.from(h, (entry) => Array.from(entry)));
        }
        const headers = {};
        for (const [name, value] of Object.entries(h)) {
            if (value !== undefined)
                headers[name] = value;
        }
        return headers;
    };
    return apiFetch(getRegenerateRecoveryCodesUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
        body: JSON.stringify(staffTotpRequest)
    });
};
export const getRegenerateRecoveryCodesMutationKey = () => ['regenerateRecoveryCodes'];
export const getRegenerateRecoveryCodesMutationOptions = (options) => {
    const mutationKey = getRegenerateRecoveryCodesMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options ?
        options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
            options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey, }, request: undefined };
    const mutationFn = (props) => {
        const { data } = props ?? {};
        return regenerateRecoveryCodes(data, requestOptions);
    };
    return { mutationFn, ...mutationOptions };
};
/**
* @summary Выпустить новые коды восстановления (старые перестают действовать)
*/
export const useRegenerateRecoveryCodes = (options, queryClient) => {
    return useMutation(getRegenerateRecoveryCodesMutationOptions(options), queryClient);
};
export const getGetMeUrl = () => {
    return `/api/v1/staff/me`;
};
/**
 * @summary Текущий сотрудник, состояние входа и права
 */
export const getMe = async (options) => {
    return apiFetch(getGetMeUrl(), {
        ...options,
        method: 'GET'
    });
};
export const getGetMeQueryKey = () => {
    return [
        `/api/v1/staff/me`
    ];
};
export const getGetMeQueryOptions = (options) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetMeQueryKey();
    const queryFn = ({ signal }) => getMe({ signal, ...requestOptions });
    return { queryKey, queryFn, ...queryOptions };
};
/**
 * @summary Текущий сотрудник, состояние входа и права
 */
export function useGetMe(options, queryClient) {
    const queryOptions = getGetMeQueryOptions(options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getUpdateMyProfileUrl = () => {
    return `/api/v1/staff/me`;
};
/**
 * @summary Свой профиль: язык интерфейса
 */
export const updateMyProfile = async (updateMyProfileRequest, options) => {
    const getHeaders = (h) => {
        if (!h)
            return {};
        if (h instanceof Headers)
            return Object.fromEntries(h.entries());
        if (Symbol.iterator in h) {
            return Object.fromEntries(Array.from(h, (entry) => Array.from(entry)));
        }
        const headers = {};
        for (const [name, value] of Object.entries(h)) {
            if (value !== undefined)
                headers[name] = value;
        }
        return headers;
    };
    return apiFetch(getUpdateMyProfileUrl(), {
        ...options,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
        body: JSON.stringify(updateMyProfileRequest)
    });
};
export const getUpdateMyProfileMutationKey = () => ['updateMyProfile'];
export const getUpdateMyProfileMutationOptions = (options) => {
    const mutationKey = getUpdateMyProfileMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options ?
        options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
            options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey, }, request: undefined };
    const mutationFn = (props) => {
        const { data } = props ?? {};
        return updateMyProfile(data, requestOptions);
    };
    return { mutationFn, ...mutationOptions };
};
/**
* @summary Свой профиль: язык интерфейса
*/
export const useUpdateMyProfile = (options, queryClient) => {
    return useMutation(getUpdateMyProfileMutationOptions(options), queryClient);
};
export const getSelectCurrentPointUrl = () => {
    return `/api/v1/staff/me/current-point`;
};
/**
 * @summary Выбрать рабочую точку (только из точек, где есть роль)
 */
export const selectCurrentPoint = async (selectCurrentPointRequest, options) => {
    const getHeaders = (h) => {
        if (!h)
            return {};
        if (h instanceof Headers)
            return Object.fromEntries(h.entries());
        if (Symbol.iterator in h) {
            return Object.fromEntries(Array.from(h, (entry) => Array.from(entry)));
        }
        const headers = {};
        for (const [name, value] of Object.entries(h)) {
            if (value !== undefined)
                headers[name] = value;
        }
        return headers;
    };
    return apiFetch(getSelectCurrentPointUrl(), {
        ...options,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
        body: JSON.stringify(selectCurrentPointRequest)
    });
};
export const getSelectCurrentPointMutationKey = () => ['selectCurrentPoint'];
export const getSelectCurrentPointMutationOptions = (options) => {
    const mutationKey = getSelectCurrentPointMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options ?
        options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
            options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey, }, request: undefined };
    const mutationFn = (props) => {
        const { data } = props ?? {};
        return selectCurrentPoint(data, requestOptions);
    };
    return { mutationFn, ...mutationOptions };
};
/**
* @summary Выбрать рабочую точку (только из точек, где есть роль)
*/
export const useSelectCurrentPoint = (options, queryClient) => {
    return useMutation(getSelectCurrentPointMutationOptions(options), queryClient);
};
export const getListPointsUrl = () => {
    return `/api/v1/staff/points`;
};
/**
 * @summary Точки инстанса (для выбора точки — любому вошедшему)
 */
export const listPoints = async (options) => {
    return apiFetch(getListPointsUrl(), {
        ...options,
        method: 'GET'
    });
};
export const getListPointsQueryKey = () => {
    return [
        `/api/v1/staff/points`
    ];
};
export const getListPointsQueryOptions = (options) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getListPointsQueryKey();
    const queryFn = ({ signal }) => listPoints({ signal, ...requestOptions });
    return { queryKey, queryFn, ...queryOptions };
};
/**
 * @summary Точки инстанса (для выбора точки — любому вошедшему)
 */
export function useListPoints(options, queryClient) {
    const queryOptions = getListPointsQueryOptions(options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getCreatePointUrl = () => {
    return `/api/v1/staff/points`;
};
/**
 * @summary Создать точку (право на все точки)
 */
export const createPoint = async (createPointRequest, options) => {
    const getHeaders = (h) => {
        if (!h)
            return {};
        if (h instanceof Headers)
            return Object.fromEntries(h.entries());
        if (Symbol.iterator in h) {
            return Object.fromEntries(Array.from(h, (entry) => Array.from(entry)));
        }
        const headers = {};
        for (const [name, value] of Object.entries(h)) {
            if (value !== undefined)
                headers[name] = value;
        }
        return headers;
    };
    return apiFetch(getCreatePointUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
        body: JSON.stringify(createPointRequest)
    });
};
export const getCreatePointMutationKey = () => ['createPoint'];
export const getCreatePointMutationOptions = (options) => {
    const mutationKey = getCreatePointMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options ?
        options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
            options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey, }, request: undefined };
    const mutationFn = (props) => {
        const { data } = props ?? {};
        return createPoint(data, requestOptions);
    };
    return { mutationFn, ...mutationOptions };
};
/**
* @summary Создать точку (право на все точки)
*/
export const useCreatePoint = (options, queryClient) => {
    return useMutation(getCreatePointMutationOptions(options), queryClient);
};
export const getGetPointUrl = (pointId) => {
    return `/api/v1/staff/points/${pointId}`;
};
/**
 * @summary Точка
 */
export const getPoint = async (pointId, options) => {
    return apiFetch(getGetPointUrl(pointId), {
        ...options,
        method: 'GET'
    });
};
export const getGetPointQueryKey = (pointId) => {
    return [
        `/api/v1/staff/points/${pointId}`
    ];
};
export const getGetPointQueryOptions = (pointId, options) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetPointQueryKey(pointId);
    const queryFn = ({ signal }) => getPoint(pointId, { signal, ...requestOptions });
    return { queryKey, queryFn, enabled: pointId !== null && pointId !== undefined, ...queryOptions };
};
/**
 * @summary Точка
 */
export function useGetPoint(pointId, options, queryClient) {
    const queryOptions = getGetPointQueryOptions(pointId, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getUpdatePointUrl = (pointId) => {
    return `/api/v1/staff/points/${pointId}`;
};
/**
 * @summary Изменить или деактивировать точку
 */
export const updatePoint = async (pointId, updatePointRequest, options) => {
    const getHeaders = (h) => {
        if (!h)
            return {};
        if (h instanceof Headers)
            return Object.fromEntries(h.entries());
        if (Symbol.iterator in h) {
            return Object.fromEntries(Array.from(h, (entry) => Array.from(entry)));
        }
        const headers = {};
        for (const [name, value] of Object.entries(h)) {
            if (value !== undefined)
                headers[name] = value;
        }
        return headers;
    };
    return apiFetch(getUpdatePointUrl(pointId), {
        ...options,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
        body: JSON.stringify(updatePointRequest)
    });
};
export const getUpdatePointMutationKey = () => ['updatePoint'];
export const getUpdatePointMutationOptions = (options) => {
    const mutationKey = getUpdatePointMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options ?
        options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
            options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey, }, request: undefined };
    const mutationFn = (props) => {
        const { pointId, data } = props ?? {};
        return updatePoint(pointId, data, requestOptions);
    };
    return { mutationFn, ...mutationOptions };
};
/**
* @summary Изменить или деактивировать точку
*/
export const useUpdatePoint = (options, queryClient) => {
    return useMutation(getUpdatePointMutationOptions(options), queryClient);
};
export const getListPointExceptionsUrl = (pointId, params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/v1/staff/points/${pointId}/exceptions?${stringifiedParams}` : `/api/v1/staff/points/${pointId}/exceptions`;
};
/**
 * @summary Исключения из расписания точки с даты (по умолчанию — с сегодня)
 */
export const listPointExceptions = async (pointId, params, options) => {
    return apiFetch(getListPointExceptionsUrl(pointId, params), {
        ...options,
        method: 'GET'
    });
};
export const getListPointExceptionsQueryKey = (pointId, params) => {
    return [
        `/api/v1/staff/points/${pointId}/exceptions`, ...(params ? [params] : [])
    ];
};
export const getListPointExceptionsQueryOptions = (pointId, params, options) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getListPointExceptionsQueryKey(pointId, params);
    const queryFn = ({ signal }) => listPointExceptions(pointId, params, { signal, ...requestOptions });
    return { queryKey, queryFn, enabled: pointId !== null && pointId !== undefined, ...queryOptions };
};
/**
 * @summary Исключения из расписания точки с даты (по умолчанию — с сегодня)
 */
export function useListPointExceptions(pointId, params, options, queryClient) {
    const queryOptions = getListPointExceptionsQueryOptions(pointId, params, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getCreatePointExceptionUrl = (pointId) => {
    return `/api/v1/staff/points/${pointId}/exceptions`;
};
/**
 * @summary Исключение на дату: закрыто или особые часы; на дату — одно
 */
export const createPointException = async (pointId, createPointExceptionRequest, options) => {
    const getHeaders = (h) => {
        if (!h)
            return {};
        if (h instanceof Headers)
            return Object.fromEntries(h.entries());
        if (Symbol.iterator in h) {
            return Object.fromEntries(Array.from(h, (entry) => Array.from(entry)));
        }
        const headers = {};
        for (const [name, value] of Object.entries(h)) {
            if (value !== undefined)
                headers[name] = value;
        }
        return headers;
    };
    return apiFetch(getCreatePointExceptionUrl(pointId), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
        body: JSON.stringify(createPointExceptionRequest)
    });
};
export const getCreatePointExceptionMutationKey = () => ['createPointException'];
export const getCreatePointExceptionMutationOptions = (options) => {
    const mutationKey = getCreatePointExceptionMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options ?
        options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
            options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey, }, request: undefined };
    const mutationFn = (props) => {
        const { pointId, data } = props ?? {};
        return createPointException(pointId, data, requestOptions);
    };
    return { mutationFn, ...mutationOptions };
};
/**
* @summary Исключение на дату: закрыто или особые часы; на дату — одно
*/
export const useCreatePointException = (options, queryClient) => {
    return useMutation(getCreatePointExceptionMutationOptions(options), queryClient);
};
export const getDeletePointExceptionUrl = (pointId, exceptionId) => {
    return `/api/v1/staff/points/${pointId}/exceptions/${exceptionId}`;
};
/**
 * @summary Удалить исключение — действует недельное расписание
 */
export const deletePointException = async (pointId, exceptionId, options) => {
    return apiFetch(getDeletePointExceptionUrl(pointId, exceptionId), {
        ...options,
        method: 'DELETE'
    });
};
export const getDeletePointExceptionMutationKey = () => ['deletePointException'];
export const getDeletePointExceptionMutationOptions = (options) => {
    const mutationKey = getDeletePointExceptionMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options ?
        options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
            options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey, }, request: undefined };
    const mutationFn = (props) => {
        const { pointId, exceptionId } = props ?? {};
        return deletePointException(pointId, exceptionId, requestOptions);
    };
    return { mutationFn, ...mutationOptions };
};
/**
* @summary Удалить исключение — действует недельное расписание
*/
export const useDeletePointException = (options, queryClient) => {
    return useMutation(getDeletePointExceptionMutationOptions(options), queryClient);
};
export const getGetPointCalendarUrl = (pointId, params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/v1/staff/points/${pointId}/calendar?${stringifiedParams}` : `/api/v1/staff/points/${pointId}/calendar`;
};
/**
 * @summary Часы работы точки по дням: расписание, исключения, праздники страны
 */
export const getPointCalendar = async (pointId, params, options) => {
    return apiFetch(getGetPointCalendarUrl(pointId, params), {
        ...options,
        method: 'GET'
    });
};
export const getGetPointCalendarQueryKey = (pointId, params) => {
    return [
        `/api/v1/staff/points/${pointId}/calendar`, ...(params ? [params] : [])
    ];
};
export const getGetPointCalendarQueryOptions = (pointId, params, options) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetPointCalendarQueryKey(pointId, params);
    const queryFn = ({ signal }) => getPointCalendar(pointId, params, { signal, ...requestOptions });
    return { queryKey, queryFn, enabled: pointId !== null && pointId !== undefined, ...queryOptions };
};
/**
 * @summary Часы работы точки по дням: расписание, исключения, праздники страны
 */
export function useGetPointCalendar(pointId, params, options, queryClient) {
    const queryOptions = getGetPointCalendarQueryOptions(pointId, params, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetSettingsUrl = () => {
    return `/api/v1/staff/settings`;
};
/**
 * @summary Настройки инстанса (право на все точки)
 */
export const getSettings = async (options) => {
    return apiFetch(getGetSettingsUrl(), {
        ...options,
        method: 'GET'
    });
};
export const getGetSettingsQueryKey = () => {
    return [
        `/api/v1/staff/settings`
    ];
};
export const getGetSettingsQueryOptions = (options) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetSettingsQueryKey();
    const queryFn = ({ signal }) => getSettings({ signal, ...requestOptions });
    return { queryKey, queryFn, ...queryOptions };
};
/**
 * @summary Настройки инстанса (право на все точки)
 */
export function useGetSettings(options, queryClient) {
    const queryOptions = getGetSettingsQueryOptions(options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getUpdateSettingUrl = () => {
    return `/api/v1/staff/settings`;
};
/**
 * @summary Сохранить настройку; 409 — её уже изменил кто-то другой
 */
export const updateSetting = async (updateSettingRequest, options) => {
    const getHeaders = (h) => {
        if (!h)
            return {};
        if (h instanceof Headers)
            return Object.fromEntries(h.entries());
        if (Symbol.iterator in h) {
            return Object.fromEntries(Array.from(h, (entry) => Array.from(entry)));
        }
        const headers = {};
        for (const [name, value] of Object.entries(h)) {
            if (value !== undefined)
                headers[name] = value;
        }
        return headers;
    };
    return apiFetch(getUpdateSettingUrl(), {
        ...options,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
        body: JSON.stringify(updateSettingRequest)
    });
};
export const getUpdateSettingMutationKey = () => ['updateSetting'];
export const getUpdateSettingMutationOptions = (options) => {
    const mutationKey = getUpdateSettingMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options ?
        options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
            options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey, }, request: undefined };
    const mutationFn = (props) => {
        const { data } = props ?? {};
        return updateSetting(data, requestOptions);
    };
    return { mutationFn, ...mutationOptions };
};
/**
* @summary Сохранить настройку; 409 — её уже изменил кто-то другой
*/
export const useUpdateSetting = (options, queryClient) => {
    return useMutation(getUpdateSettingMutationOptions(options), queryClient);
};
export const getCreateUploadUrl = () => {
    return `/api/v1/staff/files/uploads`;
};
/**
 * @summary Начать загрузку файла: multipart-загрузка в S3 напрямую из браузера
 */
export const createUpload = async (createUploadRequest, options) => {
    const getHeaders = (h) => {
        if (!h)
            return {};
        if (h instanceof Headers)
            return Object.fromEntries(h.entries());
        if (Symbol.iterator in h) {
            return Object.fromEntries(Array.from(h, (entry) => Array.from(entry)));
        }
        const headers = {};
        for (const [name, value] of Object.entries(h)) {
            if (value !== undefined)
                headers[name] = value;
        }
        return headers;
    };
    return apiFetch(getCreateUploadUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
        body: JSON.stringify(createUploadRequest)
    });
};
export const getCreateUploadMutationKey = () => ['createUpload'];
export const getCreateUploadMutationOptions = (options) => {
    const mutationKey = getCreateUploadMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options ?
        options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
            options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey, }, request: undefined };
    const mutationFn = (props) => {
        const { data } = props ?? {};
        return createUpload(data, requestOptions);
    };
    return { mutationFn, ...mutationOptions };
};
/**
* @summary Начать загрузку файла: multipart-загрузка в S3 напрямую из браузера
*/
export const useCreateUpload = (options, queryClient) => {
    return useMutation(getCreateUploadMutationOptions(options), queryClient);
};
export const getSignUploadPartUrl = (fileId) => {
    return `/api/v1/staff/files/uploads/${fileId}/parts`;
};
/**
 * @summary Ссылка для загрузки одной части (живёт 15 минут)
 */
export const signUploadPart = async (fileId, signPartRequest, options) => {
    const getHeaders = (h) => {
        if (!h)
            return {};
        if (h instanceof Headers)
            return Object.fromEntries(h.entries());
        if (Symbol.iterator in h) {
            return Object.fromEntries(Array.from(h, (entry) => Array.from(entry)));
        }
        const headers = {};
        for (const [name, value] of Object.entries(h)) {
            if (value !== undefined)
                headers[name] = value;
        }
        return headers;
    };
    return apiFetch(getSignUploadPartUrl(fileId), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
        body: JSON.stringify(signPartRequest)
    });
};
export const getSignUploadPartMutationKey = () => ['signUploadPart'];
export const getSignUploadPartMutationOptions = (options) => {
    const mutationKey = getSignUploadPartMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options ?
        options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
            options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey, }, request: undefined };
    const mutationFn = (props) => {
        const { fileId, data } = props ?? {};
        return signUploadPart(fileId, data, requestOptions);
    };
    return { mutationFn, ...mutationOptions };
};
/**
* @summary Ссылка для загрузки одной части (живёт 15 минут)
*/
export const useSignUploadPart = (options, queryClient) => {
    return useMutation(getSignUploadPartMutationOptions(options), queryClient);
};
export const getListUploadPartsUrl = (fileId) => {
    return `/api/v1/staff/files/uploads/${fileId}/parts`;
};
/**
 * @summary Уже загруженные части — чтобы докачать после обрыва
 */
export const listUploadParts = async (fileId, options) => {
    return apiFetch(getListUploadPartsUrl(fileId), {
        ...options,
        method: 'GET'
    });
};
export const getListUploadPartsQueryKey = (fileId) => {
    return [
        `/api/v1/staff/files/uploads/${fileId}/parts`
    ];
};
export const getListUploadPartsQueryOptions = (fileId, options) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getListUploadPartsQueryKey(fileId);
    const queryFn = ({ signal }) => listUploadParts(fileId, { signal, ...requestOptions });
    return { queryKey, queryFn, enabled: fileId !== null && fileId !== undefined, ...queryOptions };
};
/**
 * @summary Уже загруженные части — чтобы докачать после обрыва
 */
export function useListUploadParts(fileId, options, queryClient) {
    const queryOptions = getListUploadPartsQueryOptions(fileId, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getCompleteUploadUrl = (fileId) => {
    return `/api/v1/staff/files/uploads/${fileId}/complete`;
};
/**
 * @summary Завершить загрузку: сервер проверяет размер и формат по содержимому; не прошедший проверку файл удаляется и получает статус rejected
 */
export const completeUpload = async (fileId, completeUploadRequest, options) => {
    const getHeaders = (h) => {
        if (!h)
            return {};
        if (h instanceof Headers)
            return Object.fromEntries(h.entries());
        if (Symbol.iterator in h) {
            return Object.fromEntries(Array.from(h, (entry) => Array.from(entry)));
        }
        const headers = {};
        for (const [name, value] of Object.entries(h)) {
            if (value !== undefined)
                headers[name] = value;
        }
        return headers;
    };
    return apiFetch(getCompleteUploadUrl(fileId), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
        body: JSON.stringify(completeUploadRequest)
    });
};
export const getCompleteUploadMutationKey = () => ['completeUpload'];
export const getCompleteUploadMutationOptions = (options) => {
    const mutationKey = getCompleteUploadMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options ?
        options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
            options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey, }, request: undefined };
    const mutationFn = (props) => {
        const { fileId, data } = props ?? {};
        return completeUpload(fileId, data, requestOptions);
    };
    return { mutationFn, ...mutationOptions };
};
/**
* @summary Завершить загрузку: сервер проверяет размер и формат по содержимому; не прошедший проверку файл удаляется и получает статус rejected
*/
export const useCompleteUpload = (options, queryClient) => {
    return useMutation(getCompleteUploadMutationOptions(options), queryClient);
};
export const getAbortUploadUrl = (fileId) => {
    return `/api/v1/staff/files/uploads/${fileId}/abort`;
};
/**
 * @summary Отменить загрузку: загруженные части удаляются
 */
export const abortUpload = async (fileId, options) => {
    return apiFetch(getAbortUploadUrl(fileId), {
        ...options,
        method: 'POST'
    });
};
export const getAbortUploadMutationKey = () => ['abortUpload'];
export const getAbortUploadMutationOptions = (options) => {
    const mutationKey = getAbortUploadMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options ?
        options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
            options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey, }, request: undefined };
    const mutationFn = (props) => {
        const { fileId } = props ?? {};
        return abortUpload(fileId, requestOptions);
    };
    return { mutationFn, ...mutationOptions };
};
/**
* @summary Отменить загрузку: загруженные части удаляются
*/
export const useAbortUpload = (options, queryClient) => {
    return useMutation(getAbortUploadMutationOptions(options), queryClient);
};
export const getGetFileUrl = (fileId) => {
    return `/api/v1/staff/files/${fileId}`;
};
/**
 * @summary Файл: состояние, метаданные, ссылки на превью
 */
export const getFile = async (fileId, options) => {
    return apiFetch(getGetFileUrl(fileId), {
        ...options,
        method: 'GET'
    });
};
export const getGetFileQueryKey = (fileId) => {
    return [
        `/api/v1/staff/files/${fileId}`
    ];
};
export const getGetFileQueryOptions = (fileId, options) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetFileQueryKey(fileId);
    const queryFn = ({ signal }) => getFile(fileId, { signal, ...requestOptions });
    return { queryKey, queryFn, enabled: fileId !== null && fileId !== undefined, ...queryOptions };
};
/**
 * @summary Файл: состояние, метаданные, ссылки на превью
 */
export function useGetFile(fileId, options, queryClient) {
    const queryOptions = getGetFileQueryOptions(fileId, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getCreateDownloadLinkUrl = (fileId) => {
    return `/api/v1/staff/files/${fileId}/download`;
};
/**
 * @summary Ссылка на оригинал (5 минут); скачивание пишется в журнал скачиваний
 */
export const createDownloadLink = async (fileId, options) => {
    return apiFetch(getCreateDownloadLinkUrl(fileId), {
        ...options,
        method: 'POST'
    });
};
export const getCreateDownloadLinkMutationKey = () => ['createDownloadLink'];
export const getCreateDownloadLinkMutationOptions = (options) => {
    const mutationKey = getCreateDownloadLinkMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options ?
        options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
            options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey, }, request: undefined };
    const mutationFn = (props) => {
        const { fileId } = props ?? {};
        return createDownloadLink(fileId, requestOptions);
    };
    return { mutationFn, ...mutationOptions };
};
/**
* @summary Ссылка на оригинал (5 минут); скачивание пишется в журнал скачиваний
*/
export const useCreateDownloadLink = (options, queryClient) => {
    return useMutation(getCreateDownloadLinkMutationOptions(options), queryClient);
};
export const getRequestPasswordResetUrl = () => {
    return `/api/v1/staff/auth/password-reset`;
};
/**
 * @summary «Забыли пароль?»: письмо со ссылкой, если учётка активна и пароль задан; ответ одинаков для любого адреса
 */
export const requestPasswordReset = async (passwordResetRequest, options) => {
    const getHeaders = (h) => {
        if (!h)
            return {};
        if (h instanceof Headers)
            return Object.fromEntries(h.entries());
        if (Symbol.iterator in h) {
            return Object.fromEntries(Array.from(h, (entry) => Array.from(entry)));
        }
        const headers = {};
        for (const [name, value] of Object.entries(h)) {
            if (value !== undefined)
                headers[name] = value;
        }
        return headers;
    };
    return apiFetch(getRequestPasswordResetUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
        body: JSON.stringify(passwordResetRequest)
    });
};
export const getRequestPasswordResetMutationKey = () => ['requestPasswordReset'];
export const getRequestPasswordResetMutationOptions = (options) => {
    const mutationKey = getRequestPasswordResetMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options ?
        options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
            options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey, }, request: undefined };
    const mutationFn = (props) => {
        const { data } = props ?? {};
        return requestPasswordReset(data, requestOptions);
    };
    return { mutationFn, ...mutationOptions };
};
/**
* @summary «Забыли пароль?»: письмо со ссылкой, если учётка активна и пароль задан; ответ одинаков для любого адреса
*/
export const useRequestPasswordReset = (options, queryClient) => {
    return useMutation(getRequestPasswordResetMutationOptions(options), queryClient);
};
export const getSendTestEmailUrl = () => {
    return `/api/v1/staff/notifications/test-email`;
};
/**
 * @summary Тестовое письмо на адрес текущего сотрудника
 */
export const sendTestEmail = async (options) => {
    return apiFetch(getSendTestEmailUrl(), {
        ...options,
        method: 'POST'
    });
};
export const getSendTestEmailMutationKey = () => ['sendTestEmail'];
export const getSendTestEmailMutationOptions = (options) => {
    const mutationKey = getSendTestEmailMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options ?
        options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
            options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey, }, request: undefined };
    const mutationFn = () => {
        return sendTestEmail(requestOptions);
    };
    return { mutationFn, ...mutationOptions };
};
/**
* @summary Тестовое письмо на адрес текущего сотрудника
*/
export const useSendTestEmail = (options, queryClient) => {
    return useMutation(getSendTestEmailMutationOptions(options), queryClient);
};
export const getGetNotificationUrl = (notificationId) => {
    return `/api/v1/staff/notifications/${notificationId}`;
};
/**
 * @summary Состояние уведомления
 */
export const getNotification = async (notificationId, options) => {
    return apiFetch(getGetNotificationUrl(notificationId), {
        ...options,
        method: 'GET'
    });
};
export const getGetNotificationQueryKey = (notificationId) => {
    return [
        `/api/v1/staff/notifications/${notificationId}`
    ];
};
export const getGetNotificationQueryOptions = (notificationId, options) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetNotificationQueryKey(notificationId);
    const queryFn = ({ signal }) => getNotification(notificationId, { signal, ...requestOptions });
    return { queryKey, queryFn, enabled: notificationId !== null && notificationId !== undefined, ...queryOptions };
};
/**
 * @summary Состояние уведомления
 */
export function useGetNotification(notificationId, options, queryClient) {
    const queryOptions = getGetNotificationQueryOptions(notificationId, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getListRolesUrl = () => {
    return `/api/v1/staff/roles`;
};
/**
 * @summary Роли и их права
 */
export const listRoles = async (options) => {
    return apiFetch(getListRolesUrl(), {
        ...options,
        method: 'GET'
    });
};
export const getListRolesQueryKey = () => {
    return [
        `/api/v1/staff/roles`
    ];
};
export const getListRolesQueryOptions = (options) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getListRolesQueryKey();
    const queryFn = ({ signal }) => listRoles({ signal, ...requestOptions });
    return { queryKey, queryFn, ...queryOptions };
};
/**
 * @summary Роли и их права
 */
export function useListRoles(options, queryClient) {
    const queryOptions = getListRolesQueryOptions(options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getCreateRoleUrl = () => {
    return `/api/v1/staff/roles`;
};
/**
 * @summary Создать свою роль
 */
export const createRole = async (createRoleRequest, options) => {
    const getHeaders = (h) => {
        if (!h)
            return {};
        if (h instanceof Headers)
            return Object.fromEntries(h.entries());
        if (Symbol.iterator in h) {
            return Object.fromEntries(Array.from(h, (entry) => Array.from(entry)));
        }
        const headers = {};
        for (const [name, value] of Object.entries(h)) {
            if (value !== undefined)
                headers[name] = value;
        }
        return headers;
    };
    return apiFetch(getCreateRoleUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
        body: JSON.stringify(createRoleRequest)
    });
};
export const getCreateRoleMutationKey = () => ['createRole'];
export const getCreateRoleMutationOptions = (options) => {
    const mutationKey = getCreateRoleMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options ?
        options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
            options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey, }, request: undefined };
    const mutationFn = (props) => {
        const { data } = props ?? {};
        return createRole(data, requestOptions);
    };
    return { mutationFn, ...mutationOptions };
};
/**
* @summary Создать свою роль
*/
export const useCreateRole = (options, queryClient) => {
    return useMutation(getCreateRoleMutationOptions(options), queryClient);
};
export const getUpdateRoleUrl = (roleId) => {
    return `/api/v1/staff/roles/${roleId}`;
};
/**
 * @summary Изменить роль: имя своей роли, права, обязательность 2FA, предложенные права
 */
export const updateRole = async (roleId, updateRoleRequest, options) => {
    const getHeaders = (h) => {
        if (!h)
            return {};
        if (h instanceof Headers)
            return Object.fromEntries(h.entries());
        if (Symbol.iterator in h) {
            return Object.fromEntries(Array.from(h, (entry) => Array.from(entry)));
        }
        const headers = {};
        for (const [name, value] of Object.entries(h)) {
            if (value !== undefined)
                headers[name] = value;
        }
        return headers;
    };
    return apiFetch(getUpdateRoleUrl(roleId), {
        ...options,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
        body: JSON.stringify(updateRoleRequest)
    });
};
export const getUpdateRoleMutationKey = () => ['updateRole'];
export const getUpdateRoleMutationOptions = (options) => {
    const mutationKey = getUpdateRoleMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options ?
        options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
            options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey, }, request: undefined };
    const mutationFn = (props) => {
        const { roleId, data } = props ?? {};
        return updateRole(roleId, data, requestOptions);
    };
    return { mutationFn, ...mutationOptions };
};
/**
* @summary Изменить роль: имя своей роли, права, обязательность 2FA, предложенные права
*/
export const useUpdateRole = (options, queryClient) => {
    return useMutation(getUpdateRoleMutationOptions(options), queryClient);
};
export const getDeleteRoleUrl = (roleId) => {
    return `/api/v1/staff/roles/${roleId}`;
};
/**
 * @summary Удалить свою роль без назначений
 */
export const deleteRole = async (roleId, options) => {
    return apiFetch(getDeleteRoleUrl(roleId), {
        ...options,
        method: 'DELETE'
    });
};
export const getDeleteRoleMutationKey = () => ['deleteRole'];
export const getDeleteRoleMutationOptions = (options) => {
    const mutationKey = getDeleteRoleMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options ?
        options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
            options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey, }, request: undefined };
    const mutationFn = (props) => {
        const { roleId } = props ?? {};
        return deleteRole(roleId, requestOptions);
    };
    return { mutationFn, ...mutationOptions };
};
/**
* @summary Удалить свою роль без назначений
*/
export const useDeleteRole = (options, queryClient) => {
    return useMutation(getDeleteRoleMutationOptions(options), queryClient);
};
export const getGetCatalogUrl = () => {
    return `/api/v1/staff/catalog`;
};
/**
 * @summary Каталог: категории, товары и услуги с вариантами, тарифы срочности
 */
export const getCatalog = async (options) => {
    return apiFetch(getGetCatalogUrl(), {
        ...options,
        method: 'GET'
    });
};
export const getGetCatalogQueryKey = () => {
    return [
        `/api/v1/staff/catalog`
    ];
};
export const getGetCatalogQueryOptions = (options) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetCatalogQueryKey();
    const queryFn = ({ signal }) => getCatalog({ signal, ...requestOptions });
    return { queryKey, queryFn, ...queryOptions };
};
/**
 * @summary Каталог: категории, товары и услуги с вариантами, тарифы срочности
 */
export function useGetCatalog(options, queryClient) {
    const queryOptions = getGetCatalogQueryOptions(options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getCreateCategoryUrl = () => {
    return `/api/v1/staff/catalog/categories`;
};
/**
 * @summary Создать категорию
 */
export const createCategory = async (createCategoryRequest, options) => {
    const getHeaders = (h) => {
        if (!h)
            return {};
        if (h instanceof Headers)
            return Object.fromEntries(h.entries());
        if (Symbol.iterator in h) {
            return Object.fromEntries(Array.from(h, (entry) => Array.from(entry)));
        }
        const headers = {};
        for (const [name, value] of Object.entries(h)) {
            if (value !== undefined)
                headers[name] = value;
        }
        return headers;
    };
    return apiFetch(getCreateCategoryUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
        body: JSON.stringify(createCategoryRequest)
    });
};
export const getCreateCategoryMutationKey = () => ['createCategory'];
export const getCreateCategoryMutationOptions = (options) => {
    const mutationKey = getCreateCategoryMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options ?
        options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
            options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey, }, request: undefined };
    const mutationFn = (props) => {
        const { data } = props ?? {};
        return createCategory(data, requestOptions);
    };
    return { mutationFn, ...mutationOptions };
};
/**
* @summary Создать категорию
*/
export const useCreateCategory = (options, queryClient) => {
    return useMutation(getCreateCategoryMutationOptions(options), queryClient);
};
export const getUpdateCategoryUrl = (categoryId) => {
    return `/api/v1/staff/catalog/categories/${categoryId}`;
};
/**
 * @summary Изменить категорию
 */
export const updateCategory = async (categoryId, updateCategoryRequest, options) => {
    const getHeaders = (h) => {
        if (!h)
            return {};
        if (h instanceof Headers)
            return Object.fromEntries(h.entries());
        if (Symbol.iterator in h) {
            return Object.fromEntries(Array.from(h, (entry) => Array.from(entry)));
        }
        const headers = {};
        for (const [name, value] of Object.entries(h)) {
            if (value !== undefined)
                headers[name] = value;
        }
        return headers;
    };
    return apiFetch(getUpdateCategoryUrl(categoryId), {
        ...options,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
        body: JSON.stringify(updateCategoryRequest)
    });
};
export const getUpdateCategoryMutationKey = () => ['updateCategory'];
export const getUpdateCategoryMutationOptions = (options) => {
    const mutationKey = getUpdateCategoryMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options ?
        options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
            options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey, }, request: undefined };
    const mutationFn = (props) => {
        const { categoryId, data } = props ?? {};
        return updateCategory(categoryId, data, requestOptions);
    };
    return { mutationFn, ...mutationOptions };
};
/**
* @summary Изменить категорию
*/
export const useUpdateCategory = (options, queryClient) => {
    return useMutation(getUpdateCategoryMutationOptions(options), queryClient);
};
export const getCreateProductUrl = () => {
    return `/api/v1/staff/catalog/products`;
};
/**
 * @summary Создать товар или услугу со свойствами
 */
export const createProduct = async (createProductRequest, options) => {
    const getHeaders = (h) => {
        if (!h)
            return {};
        if (h instanceof Headers)
            return Object.fromEntries(h.entries());
        if (Symbol.iterator in h) {
            return Object.fromEntries(Array.from(h, (entry) => Array.from(entry)));
        }
        const headers = {};
        for (const [name, value] of Object.entries(h)) {
            if (value !== undefined)
                headers[name] = value;
        }
        return headers;
    };
    return apiFetch(getCreateProductUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
        body: JSON.stringify(createProductRequest)
    });
};
export const getCreateProductMutationKey = () => ['createProduct'];
export const getCreateProductMutationOptions = (options) => {
    const mutationKey = getCreateProductMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options ?
        options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
            options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey, }, request: undefined };
    const mutationFn = (props) => {
        const { data } = props ?? {};
        return createProduct(data, requestOptions);
    };
    return { mutationFn, ...mutationOptions };
};
/**
* @summary Создать товар или услугу со свойствами
*/
export const useCreateProduct = (options, queryClient) => {
    return useMutation(getCreateProductMutationOptions(options), queryClient);
};
export const getUpdateProductUrl = (productId) => {
    return `/api/v1/staff/catalog/products/${productId}`;
};
/**
 * @summary Изменить товар: поля, полный список свойств, доп. услуги
 */
export const updateProduct = async (productId, updateProductRequest, options) => {
    const getHeaders = (h) => {
        if (!h)
            return {};
        if (h instanceof Headers)
            return Object.fromEntries(h.entries());
        if (Symbol.iterator in h) {
            return Object.fromEntries(Array.from(h, (entry) => Array.from(entry)));
        }
        const headers = {};
        for (const [name, value] of Object.entries(h)) {
            if (value !== undefined)
                headers[name] = value;
        }
        return headers;
    };
    return apiFetch(getUpdateProductUrl(productId), {
        ...options,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
        body: JSON.stringify(updateProductRequest)
    });
};
export const getUpdateProductMutationKey = () => ['updateProduct'];
export const getUpdateProductMutationOptions = (options) => {
    const mutationKey = getUpdateProductMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options ?
        options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
            options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey, }, request: undefined };
    const mutationFn = (props) => {
        const { productId, data } = props ?? {};
        return updateProduct(productId, data, requestOptions);
    };
    return { mutationFn, ...mutationOptions };
};
/**
* @summary Изменить товар: поля, полный список свойств, доп. услуги
*/
export const useUpdateProduct = (options, queryClient) => {
    return useMutation(getUpdateProductMutationOptions(options), queryClient);
};
export const getCreateVariantsUrl = (productId) => {
    return `/api/v1/staff/catalog/products/${productId}/variants`;
};
/**
 * @summary Добавить варианты товара (допустимые сочетания свойств)
 */
export const createVariants = async (productId, createVariantsRequest, options) => {
    const getHeaders = (h) => {
        if (!h)
            return {};
        if (h instanceof Headers)
            return Object.fromEntries(h.entries());
        if (Symbol.iterator in h) {
            return Object.fromEntries(Array.from(h, (entry) => Array.from(entry)));
        }
        const headers = {};
        for (const [name, value] of Object.entries(h)) {
            if (value !== undefined)
                headers[name] = value;
        }
        return headers;
    };
    return apiFetch(getCreateVariantsUrl(productId), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
        body: JSON.stringify(createVariantsRequest)
    });
};
export const getCreateVariantsMutationKey = () => ['createVariants'];
export const getCreateVariantsMutationOptions = (options) => {
    const mutationKey = getCreateVariantsMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options ?
        options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
            options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey, }, request: undefined };
    const mutationFn = (props) => {
        const { productId, data } = props ?? {};
        return createVariants(productId, data, requestOptions);
    };
    return { mutationFn, ...mutationOptions };
};
/**
* @summary Добавить варианты товара (допустимые сочетания свойств)
*/
export const useCreateVariants = (options, queryClient) => {
    return useMutation(getCreateVariantsMutationOptions(options), queryClient);
};
export const getUpdateVariantUrl = (variantId) => {
    return `/api/v1/staff/catalog/variants/${variantId}`;
};
/**
 * @summary Изменить вариант: артикул, область печати, порядок, активность
 */
export const updateVariant = async (variantId, updateVariantRequest, options) => {
    const getHeaders = (h) => {
        if (!h)
            return {};
        if (h instanceof Headers)
            return Object.fromEntries(h.entries());
        if (Symbol.iterator in h) {
            return Object.fromEntries(Array.from(h, (entry) => Array.from(entry)));
        }
        const headers = {};
        for (const [name, value] of Object.entries(h)) {
            if (value !== undefined)
                headers[name] = value;
        }
        return headers;
    };
    return apiFetch(getUpdateVariantUrl(variantId), {
        ...options,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
        body: JSON.stringify(updateVariantRequest)
    });
};
export const getUpdateVariantMutationKey = () => ['updateVariant'];
export const getUpdateVariantMutationOptions = (options) => {
    const mutationKey = getUpdateVariantMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options ?
        options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
            options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey, }, request: undefined };
    const mutationFn = (props) => {
        const { variantId, data } = props ?? {};
        return updateVariant(variantId, data, requestOptions);
    };
    return { mutationFn, ...mutationOptions };
};
/**
* @summary Изменить вариант: артикул, область печати, порядок, активность
*/
export const useUpdateVariant = (options, queryClient) => {
    return useMutation(getUpdateVariantMutationOptions(options), queryClient);
};
export const getCreateUrgencyTierUrl = () => {
    return `/api/v1/staff/catalog/urgency-tiers`;
};
/**
 * @summary Создать тариф срочности
 */
export const createUrgencyTier = async (createUrgencyTierRequest, options) => {
    const getHeaders = (h) => {
        if (!h)
            return {};
        if (h instanceof Headers)
            return Object.fromEntries(h.entries());
        if (Symbol.iterator in h) {
            return Object.fromEntries(Array.from(h, (entry) => Array.from(entry)));
        }
        const headers = {};
        for (const [name, value] of Object.entries(h)) {
            if (value !== undefined)
                headers[name] = value;
        }
        return headers;
    };
    return apiFetch(getCreateUrgencyTierUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
        body: JSON.stringify(createUrgencyTierRequest)
    });
};
export const getCreateUrgencyTierMutationKey = () => ['createUrgencyTier'];
export const getCreateUrgencyTierMutationOptions = (options) => {
    const mutationKey = getCreateUrgencyTierMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options ?
        options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
            options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey, }, request: undefined };
    const mutationFn = (props) => {
        const { data } = props ?? {};
        return createUrgencyTier(data, requestOptions);
    };
    return { mutationFn, ...mutationOptions };
};
/**
* @summary Создать тариф срочности
*/
export const useCreateUrgencyTier = (options, queryClient) => {
    return useMutation(getCreateUrgencyTierMutationOptions(options), queryClient);
};
export const getUpdateUrgencyTierUrl = (tierId) => {
    return `/api/v1/staff/catalog/urgency-tiers/${tierId}`;
};
/**
 * @summary Изменить тариф срочности
 */
export const updateUrgencyTier = async (tierId, updateUrgencyTierRequest, options) => {
    const getHeaders = (h) => {
        if (!h)
            return {};
        if (h instanceof Headers)
            return Object.fromEntries(h.entries());
        if (Symbol.iterator in h) {
            return Object.fromEntries(Array.from(h, (entry) => Array.from(entry)));
        }
        const headers = {};
        for (const [name, value] of Object.entries(h)) {
            if (value !== undefined)
                headers[name] = value;
        }
        return headers;
    };
    return apiFetch(getUpdateUrgencyTierUrl(tierId), {
        ...options,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
        body: JSON.stringify(updateUrgencyTierRequest)
    });
};
export const getUpdateUrgencyTierMutationKey = () => ['updateUrgencyTier'];
export const getUpdateUrgencyTierMutationOptions = (options) => {
    const mutationKey = getUpdateUrgencyTierMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options ?
        options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
            options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey, }, request: undefined };
    const mutationFn = (props) => {
        const { tierId, data } = props ?? {};
        return updateUrgencyTier(tierId, data, requestOptions);
    };
    return { mutationFn, ...mutationOptions };
};
/**
* @summary Изменить тариф срочности
*/
export const useUpdateUrgencyTier = (options, queryClient) => {
    return useMutation(getUpdateUrgencyTierMutationOptions(options), queryClient);
};
export const getGetPriceListUrl = () => {
    return `/api/v1/staff/pricing`;
};
/**
 * @summary Базовый прайс и его версии
 */
export const getPriceList = async (options) => {
    return apiFetch(getGetPriceListUrl(), {
        ...options,
        method: 'GET'
    });
};
export const getGetPriceListQueryKey = () => {
    return [
        `/api/v1/staff/pricing`
    ];
};
export const getGetPriceListQueryOptions = (options) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetPriceListQueryKey();
    const queryFn = ({ signal }) => getPriceList({ signal, ...requestOptions });
    return { queryKey, queryFn, ...queryOptions };
};
/**
 * @summary Базовый прайс и его версии
 */
export function useGetPriceList(options, queryClient) {
    const queryOptions = getGetPriceListQueryOptions(options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetPriceVersionUrl = (versionId) => {
    return `/api/v1/staff/pricing/versions/${versionId}`;
};
/**
 * @summary Версия прайса со строками и наценками срочности
 */
export const getPriceVersion = async (versionId, options) => {
    return apiFetch(getGetPriceVersionUrl(versionId), {
        ...options,
        method: 'GET'
    });
};
export const getGetPriceVersionQueryKey = (versionId) => {
    return [
        `/api/v1/staff/pricing/versions/${versionId}`
    ];
};
export const getGetPriceVersionQueryOptions = (versionId, options) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetPriceVersionQueryKey(versionId);
    const queryFn = ({ signal }) => getPriceVersion(versionId, { signal, ...requestOptions });
    return { queryKey, queryFn, enabled: versionId !== null && versionId !== undefined, ...queryOptions };
};
/**
 * @summary Версия прайса со строками и наценками срочности
 */
export function useGetPriceVersion(versionId, options, queryClient) {
    const queryOptions = getGetPriceVersionQueryOptions(versionId, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getUpdatePriceVersionUrl = (versionId) => {
    return `/api/v1/staff/pricing/versions/${versionId}`;
};
/**
 * @summary Заменить строки и наценки черновика
 */
export const updatePriceVersion = async (versionId, updatePriceVersionRequest, options) => {
    const getHeaders = (h) => {
        if (!h)
            return {};
        if (h instanceof Headers)
            return Object.fromEntries(h.entries());
        if (Symbol.iterator in h) {
            return Object.fromEntries(Array.from(h, (entry) => Array.from(entry)));
        }
        const headers = {};
        for (const [name, value] of Object.entries(h)) {
            if (value !== undefined)
                headers[name] = value;
        }
        return headers;
    };
    return apiFetch(getUpdatePriceVersionUrl(versionId), {
        ...options,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
        body: JSON.stringify(updatePriceVersionRequest)
    });
};
export const getUpdatePriceVersionMutationKey = () => ['updatePriceVersion'];
export const getUpdatePriceVersionMutationOptions = (options) => {
    const mutationKey = getUpdatePriceVersionMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options ?
        options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
            options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey, }, request: undefined };
    const mutationFn = (props) => {
        const { versionId, data } = props ?? {};
        return updatePriceVersion(versionId, data, requestOptions);
    };
    return { mutationFn, ...mutationOptions };
};
/**
* @summary Заменить строки и наценки черновика
*/
export const useUpdatePriceVersion = (options, queryClient) => {
    return useMutation(getUpdatePriceVersionMutationOptions(options), queryClient);
};
export const getDeletePriceVersionUrl = (versionId) => {
    return `/api/v1/staff/pricing/versions/${versionId}`;
};
/**
 * @summary Удалить черновик
 */
export const deletePriceVersion = async (versionId, options) => {
    return apiFetch(getDeletePriceVersionUrl(versionId), {
        ...options,
        method: 'DELETE'
    });
};
export const getDeletePriceVersionMutationKey = () => ['deletePriceVersion'];
export const getDeletePriceVersionMutationOptions = (options) => {
    const mutationKey = getDeletePriceVersionMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options ?
        options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
            options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey, }, request: undefined };
    const mutationFn = (props) => {
        const { versionId } = props ?? {};
        return deletePriceVersion(versionId, requestOptions);
    };
    return { mutationFn, ...mutationOptions };
};
/**
* @summary Удалить черновик
*/
export const useDeletePriceVersion = (options, queryClient) => {
    return useMutation(getDeletePriceVersionMutationOptions(options), queryClient);
};
export const getCreatePriceVersionUrl = () => {
    return `/api/v1/staff/pricing/versions`;
};
/**
 * @summary Новый черновик — копия активной или указанной версии
 */
export const createPriceVersion = async (createPriceVersionRequest, options) => {
    const getHeaders = (h) => {
        if (!h)
            return {};
        if (h instanceof Headers)
            return Object.fromEntries(h.entries());
        if (Symbol.iterator in h) {
            return Object.fromEntries(Array.from(h, (entry) => Array.from(entry)));
        }
        const headers = {};
        for (const [name, value] of Object.entries(h)) {
            if (value !== undefined)
                headers[name] = value;
        }
        return headers;
    };
    return apiFetch(getCreatePriceVersionUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
        body: JSON.stringify(createPriceVersionRequest)
    });
};
export const getCreatePriceVersionMutationKey = () => ['createPriceVersion'];
export const getCreatePriceVersionMutationOptions = (options) => {
    const mutationKey = getCreatePriceVersionMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options ?
        options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
            options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey, }, request: undefined };
    const mutationFn = (props) => {
        const { data } = props ?? {};
        return createPriceVersion(data, requestOptions);
    };
    return { mutationFn, ...mutationOptions };
};
/**
* @summary Новый черновик — копия активной или указанной версии
*/
export const useCreatePriceVersion = (options, queryClient) => {
    return useMutation(getCreatePriceVersionMutationOptions(options), queryClient);
};
export const getDiffPriceVersionUrl = (versionId) => {
    return `/api/v1/staff/pricing/versions/${versionId}/diff`;
};
/**
 * @summary Чем версия отличается от активной
 */
export const diffPriceVersion = async (versionId, options) => {
    return apiFetch(getDiffPriceVersionUrl(versionId), {
        ...options,
        method: 'GET'
    });
};
export const getDiffPriceVersionQueryKey = (versionId) => {
    return [
        `/api/v1/staff/pricing/versions/${versionId}/diff`
    ];
};
export const getDiffPriceVersionQueryOptions = (versionId, options) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getDiffPriceVersionQueryKey(versionId);
    const queryFn = ({ signal }) => diffPriceVersion(versionId, { signal, ...requestOptions });
    return { queryKey, queryFn, enabled: versionId !== null && versionId !== undefined, ...queryOptions };
};
/**
 * @summary Чем версия отличается от активной
 */
export function useDiffPriceVersion(versionId, options, queryClient) {
    const queryOptions = getDiffPriceVersionQueryOptions(versionId, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getApplyPriceChangesUrl = () => {
    return `/api/v1/staff/pricing/apply`;
};
/**
 * @summary Изменить цены сразу: новая версия из активной с правками становится активной
 */
export const applyPriceChanges = async (applyPriceChangesRequest, options) => {
    const getHeaders = (h) => {
        if (!h)
            return {};
        if (h instanceof Headers)
            return Object.fromEntries(h.entries());
        if (Symbol.iterator in h) {
            return Object.fromEntries(Array.from(h, (entry) => Array.from(entry)));
        }
        const headers = {};
        for (const [name, value] of Object.entries(h)) {
            if (value !== undefined)
                headers[name] = value;
        }
        return headers;
    };
    return apiFetch(getApplyPriceChangesUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
        body: JSON.stringify(applyPriceChangesRequest)
    });
};
export const getApplyPriceChangesMutationKey = () => ['applyPriceChanges'];
export const getApplyPriceChangesMutationOptions = (options) => {
    const mutationKey = getApplyPriceChangesMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options ?
        options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
            options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey, }, request: undefined };
    const mutationFn = (props) => {
        const { data } = props ?? {};
        return applyPriceChanges(data, requestOptions);
    };
    return { mutationFn, ...mutationOptions };
};
/**
* @summary Изменить цены сразу: новая версия из активной с правками становится активной
*/
export const useApplyPriceChanges = (options, queryClient) => {
    return useMutation(getApplyPriceChangesMutationOptions(options), queryClient);
};
export const getActivatePriceVersionUrl = (versionId) => {
    return `/api/v1/staff/pricing/versions/${versionId}/activate`;
};
/**
 * @summary Сделать черновик активной версией; прежняя уходит в архив
 */
export const activatePriceVersion = async (versionId, options) => {
    return apiFetch(getActivatePriceVersionUrl(versionId), {
        ...options,
        method: 'POST'
    });
};
export const getActivatePriceVersionMutationKey = () => ['activatePriceVersion'];
export const getActivatePriceVersionMutationOptions = (options) => {
    const mutationKey = getActivatePriceVersionMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options ?
        options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
            options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey, }, request: undefined };
    const mutationFn = (props) => {
        const { versionId } = props ?? {};
        return activatePriceVersion(versionId, requestOptions);
    };
    return { mutationFn, ...mutationOptions };
};
/**
* @summary Сделать черновик активной версией; прежняя уходит в архив
*/
export const useActivatePriceVersion = (options, queryClient) => {
    return useMutation(getActivatePriceVersionMutationOptions(options), queryClient);
};
export const getQuotePriceUrl = () => {
    return `/api/v1/staff/pricing/quote`;
};
/**
 * @summary Расчёт цены по прайсу: разбивка, скидки, НДС
 */
export const quotePrice = async (quoteRequest, options) => {
    const getHeaders = (h) => {
        if (!h)
            return {};
        if (h instanceof Headers)
            return Object.fromEntries(h.entries());
        if (Symbol.iterator in h) {
            return Object.fromEntries(Array.from(h, (entry) => Array.from(entry)));
        }
        const headers = {};
        for (const [name, value] of Object.entries(h)) {
            if (value !== undefined)
                headers[name] = value;
        }
        return headers;
    };
    return apiFetch(getQuotePriceUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
        body: JSON.stringify(quoteRequest)
    });
};
export const getQuotePriceMutationKey = () => ['quotePrice'];
export const getQuotePriceMutationOptions = (options) => {
    const mutationKey = getQuotePriceMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options ?
        options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
            options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey, }, request: undefined };
    const mutationFn = (props) => {
        const { data } = props ?? {};
        return quotePrice(data, requestOptions);
    };
    return { mutationFn, ...mutationOptions };
};
/**
* @summary Расчёт цены по прайсу: разбивка, скидки, НДС
*/
export const useQuotePrice = (options, queryClient) => {
    return useMutation(getQuotePriceMutationOptions(options), queryClient);
};
export const getListOrderFilesUrl = (orderId) => {
    return `/api/v1/staff/orders/${orderId}/files`;
};
/**
 * @summary Файлы заказа: оригиналы, версии макета, файл для печати, вложения
 */
export const listOrderFiles = async (orderId, options) => {
    return apiFetch(getListOrderFilesUrl(orderId), {
        ...options,
        method: 'GET'
    });
};
export const getListOrderFilesQueryKey = (orderId) => {
    return [
        `/api/v1/staff/orders/${orderId}/files`
    ];
};
export const getListOrderFilesQueryOptions = (orderId, options) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getListOrderFilesQueryKey(orderId);
    const queryFn = ({ signal }) => listOrderFiles(orderId, { signal, ...requestOptions });
    return { queryKey, queryFn, enabled: orderId !== null && orderId !== undefined, ...queryOptions };
};
/**
 * @summary Файлы заказа: оригиналы, версии макета, файл для печати, вложения
 */
export function useListOrderFiles(orderId, options, queryClient) {
    const queryOptions = getListOrderFilesQueryOptions(orderId, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getAttachOrderFileUrl = (orderId) => {
    return `/api/v1/staff/orders/${orderId}/files`;
};
/**
 * @summary Привязать загруженный файл к заказу; макет — новая текущая версия позиции
 */
export const attachOrderFile = async (orderId, attachOrderFileRequest, options) => {
    const getHeaders = (h) => {
        if (!h)
            return {};
        if (h instanceof Headers)
            return Object.fromEntries(h.entries());
        if (Symbol.iterator in h) {
            return Object.fromEntries(Array.from(h, (entry) => Array.from(entry)));
        }
        const headers = {};
        for (const [name, value] of Object.entries(h)) {
            if (value !== undefined)
                headers[name] = value;
        }
        return headers;
    };
    return apiFetch(getAttachOrderFileUrl(orderId), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
        body: JSON.stringify(attachOrderFileRequest)
    });
};
export const getAttachOrderFileMutationKey = () => ['attachOrderFile'];
export const getAttachOrderFileMutationOptions = (options) => {
    const mutationKey = getAttachOrderFileMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options ?
        options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
            options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey, }, request: undefined };
    const mutationFn = (props) => {
        const { orderId, data } = props ?? {};
        return attachOrderFile(orderId, data, requestOptions);
    };
    return { mutationFn, ...mutationOptions };
};
/**
* @summary Привязать загруженный файл к заказу; макет — новая текущая версия позиции
*/
export const useAttachOrderFile = (options, queryClient) => {
    return useMutation(getAttachOrderFileMutationOptions(options), queryClient);
};
export const getMarkLayoutFinalUrl = (orderId, orderFileId) => {
    return `/api/v1/staff/orders/${orderId}/files/${orderFileId}/final`;
};
/**
 * @summary Отметить текущую версию макета финальной: как клиент её утвердил
 */
export const markLayoutFinal = async (orderId, orderFileId, markLayoutFinalRequest, options) => {
    const getHeaders = (h) => {
        if (!h)
            return {};
        if (h instanceof Headers)
            return Object.fromEntries(h.entries());
        if (Symbol.iterator in h) {
            return Object.fromEntries(Array.from(h, (entry) => Array.from(entry)));
        }
        const headers = {};
        for (const [name, value] of Object.entries(h)) {
            if (value !== undefined)
                headers[name] = value;
        }
        return headers;
    };
    return apiFetch(getMarkLayoutFinalUrl(orderId, orderFileId), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
        body: JSON.stringify(markLayoutFinalRequest)
    });
};
export const getMarkLayoutFinalMutationKey = () => ['markLayoutFinal'];
export const getMarkLayoutFinalMutationOptions = (options) => {
    const mutationKey = getMarkLayoutFinalMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options ?
        options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
            options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey, }, request: undefined };
    const mutationFn = (props) => {
        const { orderId, orderFileId, data } = props ?? {};
        return markLayoutFinal(orderId, orderFileId, data, requestOptions);
    };
    return { mutationFn, ...mutationOptions };
};
/**
* @summary Отметить текущую версию макета финальной: как клиент её утвердил
*/
export const useMarkLayoutFinal = (options, queryClient) => {
    return useMutation(getMarkLayoutFinalMutationOptions(options), queryClient);
};
export const getGrantProductionPermitUrl = (orderId) => {
    return `/api/v1/staff/orders/${orderId}/permits`;
};
/**
 * @summary Обойти условие gate производства (оплата или макет) с причиной
 */
export const grantProductionPermit = async (orderId, grantPermitRequest, options) => {
    const getHeaders = (h) => {
        if (!h)
            return {};
        if (h instanceof Headers)
            return Object.fromEntries(h.entries());
        if (Symbol.iterator in h) {
            return Object.fromEntries(Array.from(h, (entry) => Array.from(entry)));
        }
        const headers = {};
        for (const [name, value] of Object.entries(h)) {
            if (value !== undefined)
                headers[name] = value;
        }
        return headers;
    };
    return apiFetch(getGrantProductionPermitUrl(orderId), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
        body: JSON.stringify(grantPermitRequest)
    });
};
export const getGrantProductionPermitMutationKey = () => ['grantProductionPermit'];
export const getGrantProductionPermitMutationOptions = (options) => {
    const mutationKey = getGrantProductionPermitMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options ?
        options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
            options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey, }, request: undefined };
    const mutationFn = (props) => {
        const { orderId, data } = props ?? {};
        return grantProductionPermit(orderId, data, requestOptions);
    };
    return { mutationFn, ...mutationOptions };
};
/**
* @summary Обойти условие gate производства (оплата или макет) с причиной
*/
export const useGrantProductionPermit = (options, queryClient) => {
    return useMutation(getGrantProductionPermitMutationOptions(options), queryClient);
};
export const getSetOrderLocalFolderUrl = (orderId) => {
    return `/api/v1/staff/orders/${orderId}/local-folder`;
};
/**
 * @summary Ссылка на локальную папку с файлами заказа
 */
export const setOrderLocalFolder = async (orderId, setLocalFolderRequest, options) => {
    const getHeaders = (h) => {
        if (!h)
            return {};
        if (h instanceof Headers)
            return Object.fromEntries(h.entries());
        if (Symbol.iterator in h) {
            return Object.fromEntries(Array.from(h, (entry) => Array.from(entry)));
        }
        const headers = {};
        for (const [name, value] of Object.entries(h)) {
            if (value !== undefined)
                headers[name] = value;
        }
        return headers;
    };
    return apiFetch(getSetOrderLocalFolderUrl(orderId), {
        ...options,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
        body: JSON.stringify(setLocalFolderRequest)
    });
};
export const getSetOrderLocalFolderMutationKey = () => ['setOrderLocalFolder'];
export const getSetOrderLocalFolderMutationOptions = (options) => {
    const mutationKey = getSetOrderLocalFolderMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options ?
        options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
            options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey, }, request: undefined };
    const mutationFn = (props) => {
        const { orderId, data } = props ?? {};
        return setOrderLocalFolder(orderId, data, requestOptions);
    };
    return { mutationFn, ...mutationOptions };
};
/**
* @summary Ссылка на локальную папку с файлами заказа
*/
export const useSetOrderLocalFolder = (options, queryClient) => {
    return useMutation(getSetOrderLocalFolderMutationOptions(options), queryClient);
};
export const getScanOrderUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/v1/staff/orders/scan?${stringifiedParams}` : `/api/v1/staff/orders/scan`;
};
/**
 * @summary Заказ по QR, ссылке или номеру и действие для рабочей точки
 */
export const scanOrder = async (params, options) => {
    return apiFetch(getScanOrderUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getScanOrderQueryKey = (params) => {
    return [
        `/api/v1/staff/orders/scan`, ...(params ? [params] : [])
    ];
};
export const getScanOrderQueryOptions = (params, options) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getScanOrderQueryKey(params);
    const queryFn = ({ signal }) => scanOrder(params, { signal, ...requestOptions });
    return { queryKey, queryFn, ...queryOptions };
};
/**
 * @summary Заказ по QR, ссылке или номеру и действие для рабочей точки
 */
export function useScanOrder(params, options, queryClient) {
    const queryOptions = getScanOrderQueryOptions(params, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getSendOrderUrl = (orderId) => {
    return `/api/v1/staff/orders/${orderId}/send`;
};
/**
 * @summary «Отправлено»: изготовленный заказ уехал на точку выдачи
 */
export const sendOrder = async (orderId, logisticsActionRequest, options) => {
    const getHeaders = (h) => {
        if (!h)
            return {};
        if (h instanceof Headers)
            return Object.fromEntries(h.entries());
        if (Symbol.iterator in h) {
            return Object.fromEntries(Array.from(h, (entry) => Array.from(entry)));
        }
        const headers = {};
        for (const [name, value] of Object.entries(h)) {
            if (value !== undefined)
                headers[name] = value;
        }
        return headers;
    };
    return apiFetch(getSendOrderUrl(orderId), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
        body: JSON.stringify(logisticsActionRequest)
    });
};
export const getSendOrderMutationKey = () => ['sendOrder'];
export const getSendOrderMutationOptions = (options) => {
    const mutationKey = getSendOrderMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options ?
        options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
            options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey, }, request: undefined };
    const mutationFn = (props) => {
        const { orderId, data } = props ?? {};
        return sendOrder(orderId, data, requestOptions);
    };
    return { mutationFn, ...mutationOptions };
};
/**
* @summary «Отправлено»: изготовленный заказ уехал на точку выдачи
*/
export const useSendOrder = (options, queryClient) => {
    return useMutation(getSendOrderMutationOptions(options), queryClient);
};
export const getReceiveOrderUrl = (orderId) => {
    return `/api/v1/staff/orders/${orderId}/receive`;
};
/**
 * @summary «Получено» на рабочей точке; на чужой — с причиной и сменой точки выдачи
 */
export const receiveOrder = async (orderId, receiveOrderRequest, options) => {
    const getHeaders = (h) => {
        if (!h)
            return {};
        if (h instanceof Headers)
            return Object.fromEntries(h.entries());
        if (Symbol.iterator in h) {
            return Object.fromEntries(Array.from(h, (entry) => Array.from(entry)));
        }
        const headers = {};
        for (const [name, value] of Object.entries(h)) {
            if (value !== undefined)
                headers[name] = value;
        }
        return headers;
    };
    return apiFetch(getReceiveOrderUrl(orderId), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
        body: JSON.stringify(receiveOrderRequest)
    });
};
export const getReceiveOrderMutationKey = () => ['receiveOrder'];
export const getReceiveOrderMutationOptions = (options) => {
    const mutationKey = getReceiveOrderMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options ?
        options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
            options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey, }, request: undefined };
    const mutationFn = (props) => {
        const { orderId, data } = props ?? {};
        return receiveOrder(orderId, data, requestOptions);
    };
    return { mutationFn, ...mutationOptions };
};
/**
* @summary «Получено» на рабочей точке; на чужой — с причиной и сменой точки выдачи
*/
export const useReceiveOrder = (options, queryClient) => {
    return useMutation(getReceiveOrderMutationOptions(options), queryClient);
};
export const getIssueOrderUrl = (orderId) => {
    return `/api/v1/staff/orders/${orderId}/issue`;
};
/**
 * @summary Выдать заказ клиенту: оплачен полностью или с правом и причиной
 */
export const issueOrder = async (orderId, issueOrderRequest, options) => {
    const getHeaders = (h) => {
        if (!h)
            return {};
        if (h instanceof Headers)
            return Object.fromEntries(h.entries());
        if (Symbol.iterator in h) {
            return Object.fromEntries(Array.from(h, (entry) => Array.from(entry)));
        }
        const headers = {};
        for (const [name, value] of Object.entries(h)) {
            if (value !== undefined)
                headers[name] = value;
        }
        return headers;
    };
    return apiFetch(getIssueOrderUrl(orderId), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
        body: JSON.stringify(issueOrderRequest)
    });
};
export const getIssueOrderMutationKey = () => ['issueOrder'];
export const getIssueOrderMutationOptions = (options) => {
    const mutationKey = getIssueOrderMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options ?
        options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
            options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey, }, request: undefined };
    const mutationFn = (props) => {
        const { orderId, data } = props ?? {};
        return issueOrder(orderId, data, requestOptions);
    };
    return { mutationFn, ...mutationOptions };
};
/**
* @summary Выдать заказ клиенту: оплачен полностью или с правом и причиной
*/
export const useIssueOrder = (options, queryClient) => {
    return useMutation(getIssueOrderMutationOptions(options), queryClient);
};
export const getQuickIssueOrderUrl = (orderId) => {
    return `/api/v1/staff/orders/${orderId}/quick-issue`;
};
/**
 * @summary Быстрая продажа: сделано сразу — все позиции готовы и заказ выдан
 */
export const quickIssueOrder = async (orderId, quickIssueRequest, options) => {
    const getHeaders = (h) => {
        if (!h)
            return {};
        if (h instanceof Headers)
            return Object.fromEntries(h.entries());
        if (Symbol.iterator in h) {
            return Object.fromEntries(Array.from(h, (entry) => Array.from(entry)));
        }
        const headers = {};
        for (const [name, value] of Object.entries(h)) {
            if (value !== undefined)
                headers[name] = value;
        }
        return headers;
    };
    return apiFetch(getQuickIssueOrderUrl(orderId), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
        body: JSON.stringify(quickIssueRequest)
    });
};
export const getQuickIssueOrderMutationKey = () => ['quickIssueOrder'];
export const getQuickIssueOrderMutationOptions = (options) => {
    const mutationKey = getQuickIssueOrderMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options ?
        options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
            options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey, }, request: undefined };
    const mutationFn = (props) => {
        const { orderId, data } = props ?? {};
        return quickIssueOrder(orderId, data, requestOptions);
    };
    return { mutationFn, ...mutationOptions };
};
/**
* @summary Быстрая продажа: сделано сразу — все позиции готовы и заказ выдан
*/
export const useQuickIssueOrder = (options, queryClient) => {
    return useMutation(getQuickIssueOrderMutationOptions(options), queryClient);
};
export const getGetProductionQueueUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/v1/staff/production/queue?${stringifiedParams}` : `/api/v1/staff/production/queue`;
};
/**
 * @summary Очередь и чек-лист дня точки производства
 */
export const getProductionQueue = async (params, options) => {
    return apiFetch(getGetProductionQueueUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetProductionQueueQueryKey = (params) => {
    return [
        `/api/v1/staff/production/queue`, ...(params ? [params] : [])
    ];
};
export const getGetProductionQueueQueryOptions = (params, options) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetProductionQueueQueryKey(params);
    const queryFn = ({ signal }) => getProductionQueue(params, { signal, ...requestOptions });
    return { queryKey, queryFn, ...queryOptions };
};
/**
 * @summary Очередь и чек-лист дня точки производства
 */
export function useGetProductionQueue(params, options, queryClient) {
    const queryOptions = getGetProductionQueueQueryOptions(params, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getStartProductionTasksUrl = (orderId) => {
    return `/api/v1/staff/orders/${orderId}/production/start`;
};
/**
 * @summary «Начал»: первая начатая позиция переводит заказ в производство
 */
export const startProductionTasks = async (orderId, productionTasksRequest, options) => {
    const getHeaders = (h) => {
        if (!h)
            return {};
        if (h instanceof Headers)
            return Object.fromEntries(h.entries());
        if (Symbol.iterator in h) {
            return Object.fromEntries(Array.from(h, (entry) => Array.from(entry)));
        }
        const headers = {};
        for (const [name, value] of Object.entries(h)) {
            if (value !== undefined)
                headers[name] = value;
        }
        return headers;
    };
    return apiFetch(getStartProductionTasksUrl(orderId), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
        body: JSON.stringify(productionTasksRequest)
    });
};
export const getStartProductionTasksMutationKey = () => ['startProductionTasks'];
export const getStartProductionTasksMutationOptions = (options) => {
    const mutationKey = getStartProductionTasksMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options ?
        options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
            options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey, }, request: undefined };
    const mutationFn = (props) => {
        const { orderId, data } = props ?? {};
        return startProductionTasks(orderId, data, requestOptions);
    };
    return { mutationFn, ...mutationOptions };
};
/**
* @summary «Начал»: первая начатая позиция переводит заказ в производство
*/
export const useStartProductionTasks = (options, queryClient) => {
    return useMutation(getStartProductionTasksMutationOptions(options), queryClient);
};
export const getCompleteProductionTasksUrl = (orderId) => {
    return `/api/v1/staff/orders/${orderId}/production/complete`;
};
/**
 * @summary «Готово»: последняя готовая позиция — заказ изготовлен
 */
export const completeProductionTasks = async (orderId, productionTasksRequest, options) => {
    const getHeaders = (h) => {
        if (!h)
            return {};
        if (h instanceof Headers)
            return Object.fromEntries(h.entries());
        if (Symbol.iterator in h) {
            return Object.fromEntries(Array.from(h, (entry) => Array.from(entry)));
        }
        const headers = {};
        for (const [name, value] of Object.entries(h)) {
            if (value !== undefined)
                headers[name] = value;
        }
        return headers;
    };
    return apiFetch(getCompleteProductionTasksUrl(orderId), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
        body: JSON.stringify(productionTasksRequest)
    });
};
export const getCompleteProductionTasksMutationKey = () => ['completeProductionTasks'];
export const getCompleteProductionTasksMutationOptions = (options) => {
    const mutationKey = getCompleteProductionTasksMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options ?
        options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
            options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey, }, request: undefined };
    const mutationFn = (props) => {
        const { orderId, data } = props ?? {};
        return completeProductionTasks(orderId, data, requestOptions);
    };
    return { mutationFn, ...mutationOptions };
};
/**
* @summary «Готово»: последняя готовая позиция — заказ изготовлен
*/
export const useCompleteProductionTasks = (options, queryClient) => {
    return useMutation(getCompleteProductionTasksMutationOptions(options), queryClient);
};
export const getSetOrderPriorityUrl = (orderId) => {
    return `/api/v1/staff/orders/${orderId}/priority`;
};
/**
 * @summary Ручное повышение приоритета в очереди производства
 */
export const setOrderPriority = async (orderId, setOrderPriorityRequest, options) => {
    const getHeaders = (h) => {
        if (!h)
            return {};
        if (h instanceof Headers)
            return Object.fromEntries(h.entries());
        if (Symbol.iterator in h) {
            return Object.fromEntries(Array.from(h, (entry) => Array.from(entry)));
        }
        const headers = {};
        for (const [name, value] of Object.entries(h)) {
            if (value !== undefined)
                headers[name] = value;
        }
        return headers;
    };
    return apiFetch(getSetOrderPriorityUrl(orderId), {
        ...options,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
        body: JSON.stringify(setOrderPriorityRequest)
    });
};
export const getSetOrderPriorityMutationKey = () => ['setOrderPriority'];
export const getSetOrderPriorityMutationOptions = (options) => {
    const mutationKey = getSetOrderPriorityMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options ?
        options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
            options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey, }, request: undefined };
    const mutationFn = (props) => {
        const { orderId, data } = props ?? {};
        return setOrderPriority(orderId, data, requestOptions);
    };
    return { mutationFn, ...mutationOptions };
};
/**
* @summary Ручное повышение приоритета в очереди производства
*/
export const useSetOrderPriority = (options, queryClient) => {
    return useMutation(getSetOrderPriorityMutationOptions(options), queryClient);
};
export const getPrintOrderLabelUrl = (orderId) => {
    return `/api/v1/staff/orders/${orderId}/label`;
};
/**
 * @summary PDF этикетки заказа на языке этикеток country-pack
 */
export const printOrderLabel = async (orderId, options) => {
    return apiFetch(getPrintOrderLabelUrl(orderId), {
        ...options,
        method: 'POST'
    });
};
export const getPrintOrderLabelMutationKey = () => ['printOrderLabel'];
export const getPrintOrderLabelMutationOptions = (options) => {
    const mutationKey = getPrintOrderLabelMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options ?
        options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
            options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey, }, request: undefined };
    const mutationFn = (props) => {
        const { orderId } = props ?? {};
        return printOrderLabel(orderId, requestOptions);
    };
    return { mutationFn, ...mutationOptions };
};
/**
* @summary PDF этикетки заказа на языке этикеток country-pack
*/
export const usePrintOrderLabel = (options, queryClient) => {
    return useMutation(getPrintOrderLabelMutationOptions(options), queryClient);
};
export const getListOrderPaymentsUrl = (orderId) => {
    return `/api/v1/staff/orders/${orderId}/payments`;
};
/**
 * @summary Оплаты и сторно заказа
 */
export const listOrderPayments = async (orderId, options) => {
    return apiFetch(getListOrderPaymentsUrl(orderId), {
        ...options,
        method: 'GET'
    });
};
export const getListOrderPaymentsQueryKey = (orderId) => {
    return [
        `/api/v1/staff/orders/${orderId}/payments`
    ];
};
export const getListOrderPaymentsQueryOptions = (orderId, options) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getListOrderPaymentsQueryKey(orderId);
    const queryFn = ({ signal }) => listOrderPayments(orderId, { signal, ...requestOptions });
    return { queryKey, queryFn, enabled: orderId !== null && orderId !== undefined, ...queryOptions };
};
/**
 * @summary Оплаты и сторно заказа
 */
export function useListOrderPayments(orderId, options, queryClient) {
    const queryOptions = getListOrderPaymentsQueryOptions(orderId, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getAcceptPaymentUrl = (orderId) => {
    return `/api/v1/staff/orders/${orderId}/payments`;
};
/**
 * @summary Принять оплату в рабочей точке: наличные — в открытой смене; создаёт чек
 */
export const acceptPayment = async (orderId, acceptPaymentRequest, options) => {
    const getHeaders = (h) => {
        if (!h)
            return {};
        if (h instanceof Headers)
            return Object.fromEntries(h.entries());
        if (Symbol.iterator in h) {
            return Object.fromEntries(Array.from(h, (entry) => Array.from(entry)));
        }
        const headers = {};
        for (const [name, value] of Object.entries(h)) {
            if (value !== undefined)
                headers[name] = value;
        }
        return headers;
    };
    return apiFetch(getAcceptPaymentUrl(orderId), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
        body: JSON.stringify(acceptPaymentRequest)
    });
};
export const getAcceptPaymentMutationKey = () => ['acceptPayment'];
export const getAcceptPaymentMutationOptions = (options) => {
    const mutationKey = getAcceptPaymentMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options ?
        options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
            options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey, }, request: undefined };
    const mutationFn = (props) => {
        const { orderId, data } = props ?? {};
        return acceptPayment(orderId, data, requestOptions);
    };
    return { mutationFn, ...mutationOptions };
};
/**
* @summary Принять оплату в рабочей точке: наличные — в открытой смене; создаёт чек
*/
export const useAcceptPayment = (options, queryClient) => {
    return useMutation(getAcceptPaymentMutationOptions(options), queryClient);
};
export const getRefundPaymentUrl = (paymentId) => {
    return `/api/v1/staff/payments/${paymentId}/refund`;
};
/**
 * @summary Сторно оплаты тем же способом: своя наличная в открытой смене — payment.void_same_session, иначе payment.refund
 */
export const refundPayment = async (paymentId, refundPaymentRequest, options) => {
    const getHeaders = (h) => {
        if (!h)
            return {};
        if (h instanceof Headers)
            return Object.fromEntries(h.entries());
        if (Symbol.iterator in h) {
            return Object.fromEntries(Array.from(h, (entry) => Array.from(entry)));
        }
        const headers = {};
        for (const [name, value] of Object.entries(h)) {
            if (value !== undefined)
                headers[name] = value;
        }
        return headers;
    };
    return apiFetch(getRefundPaymentUrl(paymentId), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
        body: JSON.stringify(refundPaymentRequest)
    });
};
export const getRefundPaymentMutationKey = () => ['refundPayment'];
export const getRefundPaymentMutationOptions = (options) => {
    const mutationKey = getRefundPaymentMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options ?
        options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
            options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey, }, request: undefined };
    const mutationFn = (props) => {
        const { paymentId, data } = props ?? {};
        return refundPayment(paymentId, data, requestOptions);
    };
    return { mutationFn, ...mutationOptions };
};
/**
* @summary Сторно оплаты тем же способом: своя наличная в открытой смене — payment.void_same_session, иначе payment.refund
*/
export const useRefundPayment = (options, queryClient) => {
    return useMutation(getRefundPaymentMutationOptions(options), queryClient);
};
export const getPrintReceiptUrl = (receiptId) => {
    return `/api/v1/staff/receipts/${receiptId}/print`;
};
/**
 * @summary PDF чека; повторная печать — с пометкой «Копия»
 */
export const printReceipt = async (receiptId, options) => {
    return apiFetch(getPrintReceiptUrl(receiptId), {
        ...options,
        method: 'POST'
    });
};
export const getPrintReceiptMutationKey = () => ['printReceipt'];
export const getPrintReceiptMutationOptions = (options) => {
    const mutationKey = getPrintReceiptMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options ?
        options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
            options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey, }, request: undefined };
    const mutationFn = (props) => {
        const { receiptId } = props ?? {};
        return printReceipt(receiptId, requestOptions);
    };
    return { mutationFn, ...mutationOptions };
};
/**
* @summary PDF чека; повторная печать — с пометкой «Копия»
*/
export const usePrintReceipt = (options, queryClient) => {
    return useMutation(getPrintReceiptMutationOptions(options), queryClient);
};
export const getGetCurrentCashSessionUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/v1/staff/cash/sessions/current?${stringifiedParams}` : `/api/v1/staff/cash/sessions/current`;
};
/**
 * @summary Открытая смена точки с ожидаемой суммой в кассе
 */
export const getCurrentCashSession = async (params, options) => {
    return apiFetch(getGetCurrentCashSessionUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getGetCurrentCashSessionQueryKey = (params) => {
    return [
        `/api/v1/staff/cash/sessions/current`, ...(params ? [params] : [])
    ];
};
export const getGetCurrentCashSessionQueryOptions = (params, options) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetCurrentCashSessionQueryKey(params);
    const queryFn = ({ signal }) => getCurrentCashSession(params, { signal, ...requestOptions });
    return { queryKey, queryFn, ...queryOptions };
};
/**
 * @summary Открытая смена точки с ожидаемой суммой в кассе
 */
export function useGetCurrentCashSession(params, options, queryClient) {
    const queryOptions = getGetCurrentCashSessionQueryOptions(params, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getListCashSessionsUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/v1/staff/cash/sessions?${stringifiedParams}` : `/api/v1/staff/cash/sessions`;
};
/**
 * @summary Смены точки, новые сверху
 */
export const listCashSessions = async (params, options) => {
    return apiFetch(getListCashSessionsUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getListCashSessionsQueryKey = (params) => {
    return [
        `/api/v1/staff/cash/sessions`, ...(params ? [params] : [])
    ];
};
export const getListCashSessionsQueryOptions = (params, options) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getListCashSessionsQueryKey(params);
    const queryFn = ({ signal }) => listCashSessions(params, { signal, ...requestOptions });
    return { queryKey, queryFn, ...queryOptions };
};
/**
 * @summary Смены точки, новые сверху
 */
export function useListCashSessions(params, options, queryClient) {
    const queryOptions = getListCashSessionsQueryOptions(params, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getOpenCashSessionUrl = () => {
    return `/api/v1/staff/cash/sessions`;
};
/**
 * @summary Открыть смену точки с разменом
 */
export const openCashSession = async (openCashSessionRequest, options) => {
    const getHeaders = (h) => {
        if (!h)
            return {};
        if (h instanceof Headers)
            return Object.fromEntries(h.entries());
        if (Symbol.iterator in h) {
            return Object.fromEntries(Array.from(h, (entry) => Array.from(entry)));
        }
        const headers = {};
        for (const [name, value] of Object.entries(h)) {
            if (value !== undefined)
                headers[name] = value;
        }
        return headers;
    };
    return apiFetch(getOpenCashSessionUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
        body: JSON.stringify(openCashSessionRequest)
    });
};
export const getOpenCashSessionMutationKey = () => ['openCashSession'];
export const getOpenCashSessionMutationOptions = (options) => {
    const mutationKey = getOpenCashSessionMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options ?
        options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
            options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey, }, request: undefined };
    const mutationFn = (props) => {
        const { data } = props ?? {};
        return openCashSession(data, requestOptions);
    };
    return { mutationFn, ...mutationOptions };
};
/**
* @summary Открыть смену точки с разменом
*/
export const useOpenCashSession = (options, queryClient) => {
    return useMutation(getOpenCashSessionMutationOptions(options), queryClient);
};
export const getAddCashMovementUrl = (sessionId) => {
    return `/api/v1/staff/cash/sessions/${sessionId}/movements`;
};
/**
 * @summary Внесение или изъятие (инкассация) наличных с причиной
 */
export const addCashMovement = async (sessionId, cashMovementRequest, options) => {
    const getHeaders = (h) => {
        if (!h)
            return {};
        if (h instanceof Headers)
            return Object.fromEntries(h.entries());
        if (Symbol.iterator in h) {
            return Object.fromEntries(Array.from(h, (entry) => Array.from(entry)));
        }
        const headers = {};
        for (const [name, value] of Object.entries(h)) {
            if (value !== undefined)
                headers[name] = value;
        }
        return headers;
    };
    return apiFetch(getAddCashMovementUrl(sessionId), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
        body: JSON.stringify(cashMovementRequest)
    });
};
export const getAddCashMovementMutationKey = () => ['addCashMovement'];
export const getAddCashMovementMutationOptions = (options) => {
    const mutationKey = getAddCashMovementMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options ?
        options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
            options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey, }, request: undefined };
    const mutationFn = (props) => {
        const { sessionId, data } = props ?? {};
        return addCashMovement(sessionId, data, requestOptions);
    };
    return { mutationFn, ...mutationOptions };
};
/**
* @summary Внесение или изъятие (инкассация) наличных с причиной
*/
export const useAddCashMovement = (options, queryClient) => {
    return useMutation(getAddCashMovementMutationOptions(options), queryClient);
};
export const getCloseCashSessionUrl = (sessionId) => {
    return `/api/v1/staff/cash/sessions/${sessionId}/close`;
};
/**
 * @summary Закрыть смену: подсчёт, ожидаемая сумма и расхождение
 */
export const closeCashSession = async (sessionId, closeCashSessionRequest, options) => {
    const getHeaders = (h) => {
        if (!h)
            return {};
        if (h instanceof Headers)
            return Object.fromEntries(h.entries());
        if (Symbol.iterator in h) {
            return Object.fromEntries(Array.from(h, (entry) => Array.from(entry)));
        }
        const headers = {};
        for (const [name, value] of Object.entries(h)) {
            if (value !== undefined)
                headers[name] = value;
        }
        return headers;
    };
    return apiFetch(getCloseCashSessionUrl(sessionId), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
        body: JSON.stringify(closeCashSessionRequest)
    });
};
export const getCloseCashSessionMutationKey = () => ['closeCashSession'];
export const getCloseCashSessionMutationOptions = (options) => {
    const mutationKey = getCloseCashSessionMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options ?
        options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
            options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey, }, request: undefined };
    const mutationFn = (props) => {
        const { sessionId, data } = props ?? {};
        return closeCashSession(sessionId, data, requestOptions);
    };
    return { mutationFn, ...mutationOptions };
};
/**
* @summary Закрыть смену: подсчёт, ожидаемая сумма и расхождение
*/
export const useCloseCashSession = (options, queryClient) => {
    return useMutation(getCloseCashSessionMutationOptions(options), queryClient);
};
export const getPrintTestUrl = () => {
    return `/api/v1/staff/printing/test`;
};
/**
 * @summary Тестовый чек или этикетка в PDF — проверить принтер точки
 */
export const printTest = async (printTestRequest, options) => {
    const getHeaders = (h) => {
        if (!h)
            return {};
        if (h instanceof Headers)
            return Object.fromEntries(h.entries());
        if (Symbol.iterator in h) {
            return Object.fromEntries(Array.from(h, (entry) => Array.from(entry)));
        }
        const headers = {};
        for (const [name, value] of Object.entries(h)) {
            if (value !== undefined)
                headers[name] = value;
        }
        return headers;
    };
    return apiFetch(getPrintTestUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
        body: JSON.stringify(printTestRequest)
    });
};
export const getPrintTestMutationKey = () => ['printTest'];
export const getPrintTestMutationOptions = (options) => {
    const mutationKey = getPrintTestMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options ?
        options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
            options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey, }, request: undefined };
    const mutationFn = (props) => {
        const { data } = props ?? {};
        return printTest(data, requestOptions);
    };
    return { mutationFn, ...mutationOptions };
};
/**
* @summary Тестовый чек или этикетка в PDF — проверить принтер точки
*/
export const usePrintTest = (options, queryClient) => {
    return useMutation(getPrintTestMutationOptions(options), queryClient);
};
export const getGetSchedulingRulesUrl = () => {
    return `/api/v1/staff/scheduling`;
};
/**
 * @summary Правила сроков: производство по товару, точке и тарифу; перевозка; cut-off
 */
export const getSchedulingRules = async (options) => {
    return apiFetch(getGetSchedulingRulesUrl(), {
        ...options,
        method: 'GET'
    });
};
export const getGetSchedulingRulesQueryKey = () => {
    return [
        `/api/v1/staff/scheduling`
    ];
};
export const getGetSchedulingRulesQueryOptions = (options) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetSchedulingRulesQueryKey();
    const queryFn = ({ signal }) => getSchedulingRules({ signal, ...requestOptions });
    return { queryKey, queryFn, ...queryOptions };
};
/**
 * @summary Правила сроков: производство по товару, точке и тарифу; перевозка; cut-off
 */
export function useGetSchedulingRules(options, queryClient) {
    const queryOptions = getGetSchedulingRulesQueryOptions(options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getReplaceLeadTimesUrl = (productId) => {
    return `/api/v1/staff/scheduling/products/${productId}/lead-times`;
};
/**
 * @summary Заменить правила сроков товара
 */
export const replaceLeadTimes = async (productId, replaceLeadTimesRequest, options) => {
    const getHeaders = (h) => {
        if (!h)
            return {};
        if (h instanceof Headers)
            return Object.fromEntries(h.entries());
        if (Symbol.iterator in h) {
            return Object.fromEntries(Array.from(h, (entry) => Array.from(entry)));
        }
        const headers = {};
        for (const [name, value] of Object.entries(h)) {
            if (value !== undefined)
                headers[name] = value;
        }
        return headers;
    };
    return apiFetch(getReplaceLeadTimesUrl(productId), {
        ...options,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
        body: JSON.stringify(replaceLeadTimesRequest)
    });
};
export const getReplaceLeadTimesMutationKey = () => ['replaceLeadTimes'];
export const getReplaceLeadTimesMutationOptions = (options) => {
    const mutationKey = getReplaceLeadTimesMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options ?
        options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
            options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey, }, request: undefined };
    const mutationFn = (props) => {
        const { productId, data } = props ?? {};
        return replaceLeadTimes(productId, data, requestOptions);
    };
    return { mutationFn, ...mutationOptions };
};
/**
* @summary Заменить правила сроков товара
*/
export const useReplaceLeadTimes = (options, queryClient) => {
    return useMutation(getReplaceLeadTimesMutationOptions(options), queryClient);
};
export const getReplaceTransitsUrl = () => {
    return `/api/v1/staff/scheduling/transits`;
};
/**
 * @summary Заменить плечи перевозки между точками
 */
export const replaceTransits = async (replaceTransitsRequest, options) => {
    const getHeaders = (h) => {
        if (!h)
            return {};
        if (h instanceof Headers)
            return Object.fromEntries(h.entries());
        if (Symbol.iterator in h) {
            return Object.fromEntries(Array.from(h, (entry) => Array.from(entry)));
        }
        const headers = {};
        for (const [name, value] of Object.entries(h)) {
            if (value !== undefined)
                headers[name] = value;
        }
        return headers;
    };
    return apiFetch(getReplaceTransitsUrl(), {
        ...options,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
        body: JSON.stringify(replaceTransitsRequest)
    });
};
export const getReplaceTransitsMutationKey = () => ['replaceTransits'];
export const getReplaceTransitsMutationOptions = (options) => {
    const mutationKey = getReplaceTransitsMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options ?
        options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
            options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey, }, request: undefined };
    const mutationFn = (props) => {
        const { data } = props ?? {};
        return replaceTransits(data, requestOptions);
    };
    return { mutationFn, ...mutationOptions };
};
/**
* @summary Заменить плечи перевозки между точками
*/
export const useReplaceTransits = (options, queryClient) => {
    return useMutation(getReplaceTransitsMutationOptions(options), queryClient);
};
export const getEstimateScheduleUrl = () => {
    return `/api/v1/staff/scheduling/estimate`;
};
/**
 * @summary Плановые даты производства и выдачи по всем тарифам срочности
 */
export const estimateSchedule = async (estimateScheduleRequest, options) => {
    const getHeaders = (h) => {
        if (!h)
            return {};
        if (h instanceof Headers)
            return Object.fromEntries(h.entries());
        if (Symbol.iterator in h) {
            return Object.fromEntries(Array.from(h, (entry) => Array.from(entry)));
        }
        const headers = {};
        for (const [name, value] of Object.entries(h)) {
            if (value !== undefined)
                headers[name] = value;
        }
        return headers;
    };
    return apiFetch(getEstimateScheduleUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
        body: JSON.stringify(estimateScheduleRequest)
    });
};
export const getEstimateScheduleMutationKey = () => ['estimateSchedule'];
export const getEstimateScheduleMutationOptions = (options) => {
    const mutationKey = getEstimateScheduleMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options ?
        options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
            options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey, }, request: undefined };
    const mutationFn = (props) => {
        const { data } = props ?? {};
        return estimateSchedule(data, requestOptions);
    };
    return { mutationFn, ...mutationOptions };
};
/**
* @summary Плановые даты производства и выдачи по всем тарифам срочности
*/
export const useEstimateSchedule = (options, queryClient) => {
    return useMutation(getEstimateScheduleMutationOptions(options), queryClient);
};
export const getCreateOrderUrl = () => {
    return `/api/v1/staff/orders`;
};
/**
 * @summary Новый заказ-черновик в точке приёма
 */
export const createOrder = async (createOrderRequest, options) => {
    const getHeaders = (h) => {
        if (!h)
            return {};
        if (h instanceof Headers)
            return Object.fromEntries(h.entries());
        if (Symbol.iterator in h) {
            return Object.fromEntries(Array.from(h, (entry) => Array.from(entry)));
        }
        const headers = {};
        for (const [name, value] of Object.entries(h)) {
            if (value !== undefined)
                headers[name] = value;
        }
        return headers;
    };
    return apiFetch(getCreateOrderUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
        body: JSON.stringify(createOrderRequest)
    });
};
export const getCreateOrderMutationKey = () => ['createOrder'];
export const getCreateOrderMutationOptions = (options) => {
    const mutationKey = getCreateOrderMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options ?
        options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
            options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey, }, request: undefined };
    const mutationFn = (props) => {
        const { data } = props ?? {};
        return createOrder(data, requestOptions);
    };
    return { mutationFn, ...mutationOptions };
};
/**
* @summary Новый заказ-черновик в точке приёма
*/
export const useCreateOrder = (options, queryClient) => {
    return useMutation(getCreateOrderMutationOptions(options), queryClient);
};
export const getListOrdersUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = ["phase", "paymentStatus"];
        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach((v) => {
                normalizedParams.append(key, v === null ? 'null' : String(v));
            });
            return;
        }
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/v1/staff/orders?${stringifiedParams}` : `/api/v1/staff/orders`;
};
/**
 * @summary Заказы точек сотрудника: поиск и фильтры
 */
export const listOrders = async (params, options) => {
    return apiFetch(getListOrdersUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getListOrdersQueryKey = (params) => {
    return [
        `/api/v1/staff/orders`, ...(params ? [params] : [])
    ];
};
export const getListOrdersQueryOptions = (params, options) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getListOrdersQueryKey(params);
    const queryFn = ({ signal }) => listOrders(params, { signal, ...requestOptions });
    return { queryKey, queryFn, ...queryOptions };
};
/**
 * @summary Заказы точек сотрудника: поиск и фильтры
 */
export function useListOrders(params, options, queryClient) {
    const queryOptions = getListOrdersQueryOptions(params, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetOrderUrl = (orderId) => {
    return `/api/v1/staff/orders/${orderId}`;
};
/**
 * @summary Карточка заказа: позиции, оси, даты, история, комментарии
 */
export const getOrder = async (orderId, options) => {
    return apiFetch(getGetOrderUrl(orderId), {
        ...options,
        method: 'GET'
    });
};
export const getGetOrderQueryKey = (orderId) => {
    return [
        `/api/v1/staff/orders/${orderId}`
    ];
};
export const getGetOrderQueryOptions = (orderId, options) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetOrderQueryKey(orderId);
    const queryFn = ({ signal }) => getOrder(orderId, { signal, ...requestOptions });
    return { queryKey, queryFn, enabled: orderId !== null && orderId !== undefined, ...queryOptions };
};
/**
 * @summary Карточка заказа: позиции, оси, даты, история, комментарии
 */
export function useGetOrder(orderId, options, queryClient) {
    const queryOptions = getGetOrderQueryOptions(orderId, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getUpdateDraftUrl = (orderId) => {
    return `/api/v1/staff/orders/${orderId}`;
};
/**
 * @summary Изменить черновик: клиент, позиции, срочность, скидка, точки; цена и сроки пересчитываются
 */
export const updateDraft = async (orderId, updateDraftRequest, options) => {
    const getHeaders = (h) => {
        if (!h)
            return {};
        if (h instanceof Headers)
            return Object.fromEntries(h.entries());
        if (Symbol.iterator in h) {
            return Object.fromEntries(Array.from(h, (entry) => Array.from(entry)));
        }
        const headers = {};
        for (const [name, value] of Object.entries(h)) {
            if (value !== undefined)
                headers[name] = value;
        }
        return headers;
    };
    return apiFetch(getUpdateDraftUrl(orderId), {
        ...options,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
        body: JSON.stringify(updateDraftRequest)
    });
};
export const getUpdateDraftMutationKey = () => ['updateDraft'];
export const getUpdateDraftMutationOptions = (options) => {
    const mutationKey = getUpdateDraftMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options ?
        options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
            options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey, }, request: undefined };
    const mutationFn = (props) => {
        const { orderId, data } = props ?? {};
        return updateDraft(orderId, data, requestOptions);
    };
    return { mutationFn, ...mutationOptions };
};
/**
* @summary Изменить черновик: клиент, позиции, срочность, скидка, точки; цена и сроки пересчитываются
*/
export const useUpdateDraft = (options, queryClient) => {
    return useMutation(getUpdateDraftMutationOptions(options), queryClient);
};
export const getDeleteDraftUrl = (orderId) => {
    return `/api/v1/staff/orders/${orderId}`;
};
/**
 * @summary Удалить черновик
 */
export const deleteDraft = async (orderId, options) => {
    return apiFetch(getDeleteDraftUrl(orderId), {
        ...options,
        method: 'DELETE'
    });
};
export const getDeleteDraftMutationKey = () => ['deleteDraft'];
export const getDeleteDraftMutationOptions = (options) => {
    const mutationKey = getDeleteDraftMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options ?
        options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
            options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey, }, request: undefined };
    const mutationFn = (props) => {
        const { orderId } = props ?? {};
        return deleteDraft(orderId, requestOptions);
    };
    return { mutationFn, ...mutationOptions };
};
/**
* @summary Удалить черновик
*/
export const useDeleteDraft = (options, queryClient) => {
    return useMutation(getDeleteDraftMutationOptions(options), queryClient);
};
export const getPlaceOrderUrl = (orderId) => {
    return `/api/v1/staff/orders/${orderId}/place`;
};
/**
 * @summary Оформить: номер, снимки клиента и цены по активному прайсу, плановые даты
 */
export const placeOrder = async (orderId, placeOrderRequest, options) => {
    const getHeaders = (h) => {
        if (!h)
            return {};
        if (h instanceof Headers)
            return Object.fromEntries(h.entries());
        if (Symbol.iterator in h) {
            return Object.fromEntries(Array.from(h, (entry) => Array.from(entry)));
        }
        const headers = {};
        for (const [name, value] of Object.entries(h)) {
            if (value !== undefined)
                headers[name] = value;
        }
        return headers;
    };
    return apiFetch(getPlaceOrderUrl(orderId), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
        body: JSON.stringify(placeOrderRequest)
    });
};
export const getPlaceOrderMutationKey = () => ['placeOrder'];
export const getPlaceOrderMutationOptions = (options) => {
    const mutationKey = getPlaceOrderMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options ?
        options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
            options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey, }, request: undefined };
    const mutationFn = (props) => {
        const { orderId, data } = props ?? {};
        return placeOrder(orderId, data, requestOptions);
    };
    return { mutationFn, ...mutationOptions };
};
/**
* @summary Оформить: номер, снимки клиента и цены по активному прайсу, плановые даты
*/
export const usePlaceOrder = (options, queryClient) => {
    return useMutation(getPlaceOrderMutationOptions(options), queryClient);
};
export const getCancelOrderUrl = (orderId) => {
    return `/api/v1/staff/orders/${orderId}/cancel`;
};
/**
 * @summary Отменить заказ до выдачи; с начала производства — order.cancel.in_production
 */
export const cancelOrder = async (orderId, cancelOrderRequest, options) => {
    const getHeaders = (h) => {
        if (!h)
            return {};
        if (h instanceof Headers)
            return Object.fromEntries(h.entries());
        if (Symbol.iterator in h) {
            return Object.fromEntries(Array.from(h, (entry) => Array.from(entry)));
        }
        const headers = {};
        for (const [name, value] of Object.entries(h)) {
            if (value !== undefined)
                headers[name] = value;
        }
        return headers;
    };
    return apiFetch(getCancelOrderUrl(orderId), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
        body: JSON.stringify(cancelOrderRequest)
    });
};
export const getCancelOrderMutationKey = () => ['cancelOrder'];
export const getCancelOrderMutationOptions = (options) => {
    const mutationKey = getCancelOrderMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options ?
        options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
            options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey, }, request: undefined };
    const mutationFn = (props) => {
        const { orderId, data } = props ?? {};
        return cancelOrder(orderId, data, requestOptions);
    };
    return { mutationFn, ...mutationOptions };
};
/**
* @summary Отменить заказ до выдачи; с начала производства — order.cancel.in_production
*/
export const useCancelOrder = (options, queryClient) => {
    return useMutation(getCancelOrderMutationOptions(options), queryClient);
};
export const getRescheduleOrderUrl = (orderId) => {
    return `/api/v1/staff/orders/${orderId}/reschedule`;
};
/**
 * @summary Перенести плановую дату производства или выдачи
 */
export const rescheduleOrder = async (orderId, rescheduleOrderRequest, options) => {
    const getHeaders = (h) => {
        if (!h)
            return {};
        if (h instanceof Headers)
            return Object.fromEntries(h.entries());
        if (Symbol.iterator in h) {
            return Object.fromEntries(Array.from(h, (entry) => Array.from(entry)));
        }
        const headers = {};
        for (const [name, value] of Object.entries(h)) {
            if (value !== undefined)
                headers[name] = value;
        }
        return headers;
    };
    return apiFetch(getRescheduleOrderUrl(orderId), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
        body: JSON.stringify(rescheduleOrderRequest)
    });
};
export const getRescheduleOrderMutationKey = () => ['rescheduleOrder'];
export const getRescheduleOrderMutationOptions = (options) => {
    const mutationKey = getRescheduleOrderMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options ?
        options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
            options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey, }, request: undefined };
    const mutationFn = (props) => {
        const { orderId, data } = props ?? {};
        return rescheduleOrder(orderId, data, requestOptions);
    };
    return { mutationFn, ...mutationOptions };
};
/**
* @summary Перенести плановую дату производства или выдачи
*/
export const useRescheduleOrder = (options, queryClient) => {
    return useMutation(getRescheduleOrderMutationOptions(options), queryClient);
};
export const getAddOrderCommentUrl = (orderId) => {
    return `/api/v1/staff/orders/${orderId}/comments`;
};
/**
 * @summary Комментарий к заказу: внутренний или для клиента (для клиента — order.edit)
 */
export const addOrderComment = async (orderId, addOrderCommentRequest, options) => {
    const getHeaders = (h) => {
        if (!h)
            return {};
        if (h instanceof Headers)
            return Object.fromEntries(h.entries());
        if (Symbol.iterator in h) {
            return Object.fromEntries(Array.from(h, (entry) => Array.from(entry)));
        }
        const headers = {};
        for (const [name, value] of Object.entries(h)) {
            if (value !== undefined)
                headers[name] = value;
        }
        return headers;
    };
    return apiFetch(getAddOrderCommentUrl(orderId), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
        body: JSON.stringify(addOrderCommentRequest)
    });
};
export const getAddOrderCommentMutationKey = () => ['addOrderComment'];
export const getAddOrderCommentMutationOptions = (options) => {
    const mutationKey = getAddOrderCommentMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options ?
        options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
            options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey, }, request: undefined };
    const mutationFn = (props) => {
        const { orderId, data } = props ?? {};
        return addOrderComment(orderId, data, requestOptions);
    };
    return { mutationFn, ...mutationOptions };
};
/**
* @summary Комментарий к заказу: внутренний или для клиента (для клиента — order.edit)
*/
export const useAddOrderComment = (options, queryClient) => {
    return useMutation(getAddOrderCommentMutationOptions(options), queryClient);
};
export const getSearchCustomersUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/v1/staff/customers?${stringifiedParams}` : `/api/v1/staff/customers`;
};
/**
 * @summary Поиск клиентов: имя с опечатками, телефон, e-mail
 */
export const searchCustomers = async (params, options) => {
    return apiFetch(getSearchCustomersUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getSearchCustomersQueryKey = (params) => {
    return [
        `/api/v1/staff/customers`, ...(params ? [params] : [])
    ];
};
export const getSearchCustomersQueryOptions = (params, options) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getSearchCustomersQueryKey(params);
    const queryFn = ({ signal }) => searchCustomers(params, { signal, ...requestOptions });
    return { queryKey, queryFn, ...queryOptions };
};
/**
 * @summary Поиск клиентов: имя с опечатками, телефон, e-mail
 */
export function useSearchCustomers(params, options, queryClient) {
    const queryOptions = getSearchCustomersQueryOptions(params, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getCreateCustomerUrl = () => {
    return `/api/v1/staff/customers`;
};
/**
 * @summary Создать клиента
 */
export const createCustomer = async (createCustomerRequest, options) => {
    const getHeaders = (h) => {
        if (!h)
            return {};
        if (h instanceof Headers)
            return Object.fromEntries(h.entries());
        if (Symbol.iterator in h) {
            return Object.fromEntries(Array.from(h, (entry) => Array.from(entry)));
        }
        const headers = {};
        for (const [name, value] of Object.entries(h)) {
            if (value !== undefined)
                headers[name] = value;
        }
        return headers;
    };
    return apiFetch(getCreateCustomerUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
        body: JSON.stringify(createCustomerRequest)
    });
};
export const getCreateCustomerMutationKey = () => ['createCustomer'];
export const getCreateCustomerMutationOptions = (options) => {
    const mutationKey = getCreateCustomerMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options ?
        options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
            options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey, }, request: undefined };
    const mutationFn = (props) => {
        const { data } = props ?? {};
        return createCustomer(data, requestOptions);
    };
    return { mutationFn, ...mutationOptions };
};
/**
* @summary Создать клиента
*/
export const useCreateCustomer = (options, queryClient) => {
    return useMutation(getCreateCustomerMutationOptions(options), queryClient);
};
export const getFindCustomerDuplicatesUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/v1/staff/customers/duplicates?${stringifiedParams}` : `/api/v1/staff/customers/duplicates`;
};
/**
 * @summary Возможные дубли по контактам и имени — подсказка перед созданием
 */
export const findCustomerDuplicates = async (params, options) => {
    return apiFetch(getFindCustomerDuplicatesUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getFindCustomerDuplicatesQueryKey = (params) => {
    return [
        `/api/v1/staff/customers/duplicates`, ...(params ? [params] : [])
    ];
};
export const getFindCustomerDuplicatesQueryOptions = (params, options) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getFindCustomerDuplicatesQueryKey(params);
    const queryFn = ({ signal }) => findCustomerDuplicates(params, { signal, ...requestOptions });
    return { queryKey, queryFn, ...queryOptions };
};
/**
 * @summary Возможные дубли по контактам и имени — подсказка перед созданием
 */
export function useFindCustomerDuplicates(params, options, queryClient) {
    const queryOptions = getFindCustomerDuplicatesQueryOptions(params, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetCustomerUrl = (customerId) => {
    return `/api/v1/staff/customers/${customerId}`;
};
/**
 * @summary Карточка клиента
 */
export const getCustomer = async (customerId, options) => {
    return apiFetch(getGetCustomerUrl(customerId), {
        ...options,
        method: 'GET'
    });
};
export const getGetCustomerQueryKey = (customerId) => {
    return [
        `/api/v1/staff/customers/${customerId}`
    ];
};
export const getGetCustomerQueryOptions = (customerId, options) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetCustomerQueryKey(customerId);
    const queryFn = ({ signal }) => getCustomer(customerId, { signal, ...requestOptions });
    return { queryKey, queryFn, enabled: customerId !== null && customerId !== undefined, ...queryOptions };
};
/**
 * @summary Карточка клиента
 */
export function useGetCustomer(customerId, options, queryClient) {
    const queryOptions = getGetCustomerQueryOptions(customerId, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getUpdateCustomerUrl = (customerId) => {
    return `/api/v1/staff/customers/${customerId}`;
};
/**
 * @summary Изменить клиента и его контакты
 */
export const updateCustomer = async (customerId, updateCustomerRequest, options) => {
    const getHeaders = (h) => {
        if (!h)
            return {};
        if (h instanceof Headers)
            return Object.fromEntries(h.entries());
        if (Symbol.iterator in h) {
            return Object.fromEntries(Array.from(h, (entry) => Array.from(entry)));
        }
        const headers = {};
        for (const [name, value] of Object.entries(h)) {
            if (value !== undefined)
                headers[name] = value;
        }
        return headers;
    };
    return apiFetch(getUpdateCustomerUrl(customerId), {
        ...options,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
        body: JSON.stringify(updateCustomerRequest)
    });
};
export const getUpdateCustomerMutationKey = () => ['updateCustomer'];
export const getUpdateCustomerMutationOptions = (options) => {
    const mutationKey = getUpdateCustomerMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options ?
        options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
            options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey, }, request: undefined };
    const mutationFn = (props) => {
        const { customerId, data } = props ?? {};
        return updateCustomer(customerId, data, requestOptions);
    };
    return { mutationFn, ...mutationOptions };
};
/**
* @summary Изменить клиента и его контакты
*/
export const useUpdateCustomer = (options, queryClient) => {
    return useMutation(getUpdateCustomerMutationOptions(options), queryClient);
};
export const getMergeCustomerUrl = (customerId) => {
    return `/api/v1/staff/customers/${customerId}/merge`;
};
/**
 * @summary Объединить дубль с основной карточкой
 */
export const mergeCustomer = async (customerId, mergeCustomerRequest, options) => {
    const getHeaders = (h) => {
        if (!h)
            return {};
        if (h instanceof Headers)
            return Object.fromEntries(h.entries());
        if (Symbol.iterator in h) {
            return Object.fromEntries(Array.from(h, (entry) => Array.from(entry)));
        }
        const headers = {};
        for (const [name, value] of Object.entries(h)) {
            if (value !== undefined)
                headers[name] = value;
        }
        return headers;
    };
    return apiFetch(getMergeCustomerUrl(customerId), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
        body: JSON.stringify(mergeCustomerRequest)
    });
};
export const getMergeCustomerMutationKey = () => ['mergeCustomer'];
export const getMergeCustomerMutationOptions = (options) => {
    const mutationKey = getMergeCustomerMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options ?
        options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
            options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey, }, request: undefined };
    const mutationFn = (props) => {
        const { customerId, data } = props ?? {};
        return mergeCustomer(customerId, data, requestOptions);
    };
    return { mutationFn, ...mutationOptions };
};
/**
* @summary Объединить дубль с основной карточкой
*/
export const useMergeCustomer = (options, queryClient) => {
    return useMutation(getMergeCustomerMutationOptions(options), queryClient);
};
export const getExportPriceVersionUrl = (versionId) => {
    return `/api/v1/staff/pricing/versions/${versionId}/export`;
};
/**
 * @summary Выгрузить версию прайса в Excel — для правки и обратного импорта
 */
export const exportPriceVersion = async (versionId, options) => {
    return apiFetch(getExportPriceVersionUrl(versionId), {
        ...options,
        method: 'POST'
    });
};
export const getExportPriceVersionMutationKey = () => ['exportPriceVersion'];
export const getExportPriceVersionMutationOptions = (options) => {
    const mutationKey = getExportPriceVersionMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options ?
        options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
            options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey, }, request: undefined };
    const mutationFn = (props) => {
        const { versionId } = props ?? {};
        return exportPriceVersion(versionId, requestOptions);
    };
    return { mutationFn, ...mutationOptions };
};
/**
* @summary Выгрузить версию прайса в Excel — для правки и обратного импорта
*/
export const useExportPriceVersion = (options, queryClient) => {
    return useMutation(getExportPriceVersionMutationOptions(options), queryClient);
};
export const getListImportsUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/v1/staff/imports?${stringifiedParams}` : `/api/v1/staff/imports`;
};
/**
 * @summary Последние импорты (видны виды, на которые есть право)
 */
export const listImports = async (params, options) => {
    return apiFetch(getListImportsUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getListImportsQueryKey = (params) => {
    return [
        `/api/v1/staff/imports`, ...(params ? [params] : [])
    ];
};
export const getListImportsQueryOptions = (params, options) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getListImportsQueryKey(params);
    const queryFn = ({ signal }) => listImports(params, { signal, ...requestOptions });
    return { queryKey, queryFn, ...queryOptions };
};
/**
 * @summary Последние импорты (видны виды, на которые есть право)
 */
export function useListImports(params, options, queryClient) {
    const queryOptions = getListImportsQueryOptions(params, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getCreateImportUrl = () => {
    return `/api/v1/staff/imports`;
};
/**
 * @summary Начать импорт загруженного файла: прайс (pricing.manage) или клиенты (customer.edit)
 */
export const createImport = async (createImportRequest, options) => {
    const getHeaders = (h) => {
        if (!h)
            return {};
        if (h instanceof Headers)
            return Object.fromEntries(h.entries());
        if (Symbol.iterator in h) {
            return Object.fromEntries(Array.from(h, (entry) => Array.from(entry)));
        }
        const headers = {};
        for (const [name, value] of Object.entries(h)) {
            if (value !== undefined)
                headers[name] = value;
        }
        return headers;
    };
    return apiFetch(getCreateImportUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
        body: JSON.stringify(createImportRequest)
    });
};
export const getCreateImportMutationKey = () => ['createImport'];
export const getCreateImportMutationOptions = (options) => {
    const mutationKey = getCreateImportMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options ?
        options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
            options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey, }, request: undefined };
    const mutationFn = (props) => {
        const { data } = props ?? {};
        return createImport(data, requestOptions);
    };
    return { mutationFn, ...mutationOptions };
};
/**
* @summary Начать импорт загруженного файла: прайс (pricing.manage) или клиенты (customer.edit)
*/
export const useCreateImport = (options, queryClient) => {
    return useMutation(getCreateImportMutationOptions(options), queryClient);
};
export const getGetImportUrl = (jobId) => {
    return `/api/v1/staff/imports/${jobId}`;
};
/**
 * @summary Импорт: заголовки, образец, сопоставление, итоги проверки, замечания
 */
export const getImport = async (jobId, options) => {
    return apiFetch(getGetImportUrl(jobId), {
        ...options,
        method: 'GET'
    });
};
export const getGetImportQueryKey = (jobId) => {
    return [
        `/api/v1/staff/imports/${jobId}`
    ];
};
export const getGetImportQueryOptions = (jobId, options) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetImportQueryKey(jobId);
    const queryFn = ({ signal }) => getImport(jobId, { signal, ...requestOptions });
    return { queryKey, queryFn, enabled: jobId !== null && jobId !== undefined, ...queryOptions };
};
/**
 * @summary Импорт: заголовки, образец, сопоставление, итоги проверки, замечания
 */
export function useGetImport(jobId, options, queryClient) {
    const queryOptions = getGetImportQueryOptions(jobId, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getSetImportMappingUrl = (jobId) => {
    return `/api/v1/staff/imports/${jobId}/mapping`;
};
/**
 * @summary Сопоставить колонки и проверить файл без записи
 */
export const setImportMapping = async (jobId, setImportMappingRequest, options) => {
    const getHeaders = (h) => {
        if (!h)
            return {};
        if (h instanceof Headers)
            return Object.fromEntries(h.entries());
        if (Symbol.iterator in h) {
            return Object.fromEntries(Array.from(h, (entry) => Array.from(entry)));
        }
        const headers = {};
        for (const [name, value] of Object.entries(h)) {
            if (value !== undefined)
                headers[name] = value;
        }
        return headers;
    };
    return apiFetch(getSetImportMappingUrl(jobId), {
        ...options,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
        body: JSON.stringify(setImportMappingRequest)
    });
};
export const getSetImportMappingMutationKey = () => ['setImportMapping'];
export const getSetImportMappingMutationOptions = (options) => {
    const mutationKey = getSetImportMappingMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options ?
        options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
            options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey, }, request: undefined };
    const mutationFn = (props) => {
        const { jobId, data } = props ?? {};
        return setImportMapping(jobId, data, requestOptions);
    };
    return { mutationFn, ...mutationOptions };
};
/**
* @summary Сопоставить колонки и проверить файл без записи
*/
export const useSetImportMapping = (options, queryClient) => {
    return useMutation(getSetImportMappingMutationOptions(options), queryClient);
};
export const getApplyImportUrl = (jobId) => {
    return `/api/v1/staff/imports/${jobId}/apply`;
};
/**
 * @summary Применить проверенный импорт одной транзакцией; повторно нельзя
 */
export const applyImport = async (jobId, options) => {
    return apiFetch(getApplyImportUrl(jobId), {
        ...options,
        method: 'POST'
    });
};
export const getApplyImportMutationKey = () => ['applyImport'];
export const getApplyImportMutationOptions = (options) => {
    const mutationKey = getApplyImportMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options ?
        options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
            options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey, }, request: undefined };
    const mutationFn = (props) => {
        const { jobId } = props ?? {};
        return applyImport(jobId, requestOptions);
    };
    return { mutationFn, ...mutationOptions };
};
/**
* @summary Применить проверенный импорт одной транзакцией; повторно нельзя
*/
export const useApplyImport = (options, queryClient) => {
    return useMutation(getApplyImportMutationOptions(options), queryClient);
};
export const getCancelImportUrl = (jobId) => {
    return `/api/v1/staff/imports/${jobId}/cancel`;
};
/**
 * @summary Отменить импорт
 */
export const cancelImport = async (jobId, options) => {
    return apiFetch(getCancelImportUrl(jobId), {
        ...options,
        method: 'POST'
    });
};
export const getCancelImportMutationKey = () => ['cancelImport'];
export const getCancelImportMutationOptions = (options) => {
    const mutationKey = getCancelImportMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options ?
        options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
            options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey, }, request: undefined };
    const mutationFn = (props) => {
        const { jobId } = props ?? {};
        return cancelImport(jobId, requestOptions);
    };
    return { mutationFn, ...mutationOptions };
};
/**
* @summary Отменить импорт
*/
export const useCancelImport = (options, queryClient) => {
    return useMutation(getCancelImportMutationOptions(options), queryClient);
};
export const getListStaffUsersUrl = () => {
    return `/api/v1/staff/users`;
};
/**
 * @summary Сотрудники
 */
export const listStaffUsers = async (options) => {
    return apiFetch(getListStaffUsersUrl(), {
        ...options,
        method: 'GET'
    });
};
export const getListStaffUsersQueryKey = () => {
    return [
        `/api/v1/staff/users`
    ];
};
export const getListStaffUsersQueryOptions = (options) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getListStaffUsersQueryKey();
    const queryFn = ({ signal }) => listStaffUsers({ signal, ...requestOptions });
    return { queryKey, queryFn, ...queryOptions };
};
/**
 * @summary Сотрудники
 */
export function useListStaffUsers(options, queryClient) {
    const queryOptions = getListStaffUsersQueryOptions(options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getCreateStaffUserUrl = () => {
    return `/api/v1/staff/users`;
};
/**
 * @summary Пригласить сотрудника: ссылка показывается один раз или уходит письмом
 */
export const createStaffUser = async (createStaffUserRequest, options) => {
    const getHeaders = (h) => {
        if (!h)
            return {};
        if (h instanceof Headers)
            return Object.fromEntries(h.entries());
        if (Symbol.iterator in h) {
            return Object.fromEntries(Array.from(h, (entry) => Array.from(entry)));
        }
        const headers = {};
        for (const [name, value] of Object.entries(h)) {
            if (value !== undefined)
                headers[name] = value;
        }
        return headers;
    };
    return apiFetch(getCreateStaffUserUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
        body: JSON.stringify(createStaffUserRequest)
    });
};
export const getCreateStaffUserMutationKey = () => ['createStaffUser'];
export const getCreateStaffUserMutationOptions = (options) => {
    const mutationKey = getCreateStaffUserMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options ?
        options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
            options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey, }, request: undefined };
    const mutationFn = (props) => {
        const { data } = props ?? {};
        return createStaffUser(data, requestOptions);
    };
    return { mutationFn, ...mutationOptions };
};
/**
* @summary Пригласить сотрудника: ссылка показывается один раз или уходит письмом
*/
export const useCreateStaffUser = (options, queryClient) => {
    return useMutation(getCreateStaffUserMutationOptions(options), queryClient);
};
export const getGetStaffUserUrl = (userId) => {
    return `/api/v1/staff/users/${userId}`;
};
/**
 * @summary Сотрудник
 */
export const getStaffUser = async (userId, options) => {
    return apiFetch(getGetStaffUserUrl(userId), {
        ...options,
        method: 'GET'
    });
};
export const getGetStaffUserQueryKey = (userId) => {
    return [
        `/api/v1/staff/users/${userId}`
    ];
};
export const getGetStaffUserQueryOptions = (userId, options) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetStaffUserQueryKey(userId);
    const queryFn = ({ signal }) => getStaffUser(userId, { signal, ...requestOptions });
    return { queryKey, queryFn, enabled: userId !== null && userId !== undefined, ...queryOptions };
};
/**
 * @summary Сотрудник
 */
export function useGetStaffUser(userId, options, queryClient) {
    const queryOptions = getGetStaffUserQueryOptions(userId, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getUpdateStaffUserUrl = (userId) => {
    return `/api/v1/staff/users/${userId}`;
};
/**
 * @summary Изменить имя или язык сотрудника
 */
export const updateStaffUser = async (userId, updateStaffUserRequest, options) => {
    const getHeaders = (h) => {
        if (!h)
            return {};
        if (h instanceof Headers)
            return Object.fromEntries(h.entries());
        if (Symbol.iterator in h) {
            return Object.fromEntries(Array.from(h, (entry) => Array.from(entry)));
        }
        const headers = {};
        for (const [name, value] of Object.entries(h)) {
            if (value !== undefined)
                headers[name] = value;
        }
        return headers;
    };
    return apiFetch(getUpdateStaffUserUrl(userId), {
        ...options,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
        body: JSON.stringify(updateStaffUserRequest)
    });
};
export const getUpdateStaffUserMutationKey = () => ['updateStaffUser'];
export const getUpdateStaffUserMutationOptions = (options) => {
    const mutationKey = getUpdateStaffUserMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options ?
        options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
            options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey, }, request: undefined };
    const mutationFn = (props) => {
        const { userId, data } = props ?? {};
        return updateStaffUser(userId, data, requestOptions);
    };
    return { mutationFn, ...mutationOptions };
};
/**
* @summary Изменить имя или язык сотрудника
*/
export const useUpdateStaffUser = (options, queryClient) => {
    return useMutation(getUpdateStaffUserMutationOptions(options), queryClient);
};
export const getReplaceStaffAssignmentsUrl = (userId) => {
    return `/api/v1/staff/users/${userId}/assignments`;
};
/**
 * @summary Назначить роли по точкам (изменения роли Администратора — с подтверждением кодом)
 */
export const replaceStaffAssignments = async (userId, replaceAssignmentsRequest, options) => {
    const getHeaders = (h) => {
        if (!h)
            return {};
        if (h instanceof Headers)
            return Object.fromEntries(h.entries());
        if (Symbol.iterator in h) {
            return Object.fromEntries(Array.from(h, (entry) => Array.from(entry)));
        }
        const headers = {};
        for (const [name, value] of Object.entries(h)) {
            if (value !== undefined)
                headers[name] = value;
        }
        return headers;
    };
    return apiFetch(getReplaceStaffAssignmentsUrl(userId), {
        ...options,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
        body: JSON.stringify(replaceAssignmentsRequest)
    });
};
export const getReplaceStaffAssignmentsMutationKey = () => ['replaceStaffAssignments'];
export const getReplaceStaffAssignmentsMutationOptions = (options) => {
    const mutationKey = getReplaceStaffAssignmentsMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options ?
        options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
            options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey, }, request: undefined };
    const mutationFn = (props) => {
        const { userId, data } = props ?? {};
        return replaceStaffAssignments(userId, data, requestOptions);
    };
    return { mutationFn, ...mutationOptions };
};
/**
* @summary Назначить роли по точкам (изменения роли Администратора — с подтверждением кодом)
*/
export const useReplaceStaffAssignments = (options, queryClient) => {
    return useMutation(getReplaceStaffAssignmentsMutationOptions(options), queryClient);
};
export const getIssueStaffSetupLinkUrl = (userId) => {
    return `/api/v1/staff/users/${userId}/setup-link`;
};
/**
 * @summary Новая ссылка настройки (сброс пароля); сессии сотрудника завершаются
 */
export const issueStaffSetupLink = async (userId, issueSetupLinkRequest, options) => {
    const getHeaders = (h) => {
        if (!h)
            return {};
        if (h instanceof Headers)
            return Object.fromEntries(h.entries());
        if (Symbol.iterator in h) {
            return Object.fromEntries(Array.from(h, (entry) => Array.from(entry)));
        }
        const headers = {};
        for (const [name, value] of Object.entries(h)) {
            if (value !== undefined)
                headers[name] = value;
        }
        return headers;
    };
    return apiFetch(getIssueStaffSetupLinkUrl(userId), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
        body: JSON.stringify(issueSetupLinkRequest)
    });
};
export const getIssueStaffSetupLinkMutationKey = () => ['issueStaffSetupLink'];
export const getIssueStaffSetupLinkMutationOptions = (options) => {
    const mutationKey = getIssueStaffSetupLinkMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options ?
        options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
            options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey, }, request: undefined };
    const mutationFn = (props) => {
        const { userId, data } = props ?? {};
        return issueStaffSetupLink(userId, data, requestOptions);
    };
    return { mutationFn, ...mutationOptions };
};
/**
* @summary Новая ссылка настройки (сброс пароля); сессии сотрудника завершаются
*/
export const useIssueStaffSetupLink = (options, queryClient) => {
    return useMutation(getIssueStaffSetupLinkMutationOptions(options), queryClient);
};
export const getResetStaffMfaUrl = (userId) => {
    return `/api/v1/staff/users/${userId}/reset-mfa`;
};
/**
 * @summary Сбросить приложение-аутентификатор сотрудника
 */
export const resetStaffMfa = async (userId, reasonRequest, options) => {
    const getHeaders = (h) => {
        if (!h)
            return {};
        if (h instanceof Headers)
            return Object.fromEntries(h.entries());
        if (Symbol.iterator in h) {
            return Object.fromEntries(Array.from(h, (entry) => Array.from(entry)));
        }
        const headers = {};
        for (const [name, value] of Object.entries(h)) {
            if (value !== undefined)
                headers[name] = value;
        }
        return headers;
    };
    return apiFetch(getResetStaffMfaUrl(userId), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
        body: JSON.stringify(reasonRequest)
    });
};
export const getResetStaffMfaMutationKey = () => ['resetStaffMfa'];
export const getResetStaffMfaMutationOptions = (options) => {
    const mutationKey = getResetStaffMfaMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options ?
        options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
            options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey, }, request: undefined };
    const mutationFn = (props) => {
        const { userId, data } = props ?? {};
        return resetStaffMfa(userId, data, requestOptions);
    };
    return { mutationFn, ...mutationOptions };
};
/**
* @summary Сбросить приложение-аутентификатор сотрудника
*/
export const useResetStaffMfa = (options, queryClient) => {
    return useMutation(getResetStaffMfaMutationOptions(options), queryClient);
};
export const getDeactivateStaffUserUrl = (userId) => {
    return `/api/v1/staff/users/${userId}/deactivate`;
};
/**
 * @summary Деактивировать сотрудника (последнего администратора — нельзя)
 */
export const deactivateStaffUser = async (userId, reasonRequest, options) => {
    const getHeaders = (h) => {
        if (!h)
            return {};
        if (h instanceof Headers)
            return Object.fromEntries(h.entries());
        if (Symbol.iterator in h) {
            return Object.fromEntries(Array.from(h, (entry) => Array.from(entry)));
        }
        const headers = {};
        for (const [name, value] of Object.entries(h)) {
            if (value !== undefined)
                headers[name] = value;
        }
        return headers;
    };
    return apiFetch(getDeactivateStaffUserUrl(userId), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
        body: JSON.stringify(reasonRequest)
    });
};
export const getDeactivateStaffUserMutationKey = () => ['deactivateStaffUser'];
export const getDeactivateStaffUserMutationOptions = (options) => {
    const mutationKey = getDeactivateStaffUserMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options ?
        options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
            options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey, }, request: undefined };
    const mutationFn = (props) => {
        const { userId, data } = props ?? {};
        return deactivateStaffUser(userId, data, requestOptions);
    };
    return { mutationFn, ...mutationOptions };
};
/**
* @summary Деактивировать сотрудника (последнего администратора — нельзя)
*/
export const useDeactivateStaffUser = (options, queryClient) => {
    return useMutation(getDeactivateStaffUserMutationOptions(options), queryClient);
};
export const getActivateStaffUserUrl = (userId) => {
    return `/api/v1/staff/users/${userId}/activate`;
};
/**
 * @summary Вернуть доступ сотруднику
 */
export const activateStaffUser = async (userId, reasonRequest, options) => {
    const getHeaders = (h) => {
        if (!h)
            return {};
        if (h instanceof Headers)
            return Object.fromEntries(h.entries());
        if (Symbol.iterator in h) {
            return Object.fromEntries(Array.from(h, (entry) => Array.from(entry)));
        }
        const headers = {};
        for (const [name, value] of Object.entries(h)) {
            if (value !== undefined)
                headers[name] = value;
        }
        return headers;
    };
    return apiFetch(getActivateStaffUserUrl(userId), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
        body: JSON.stringify(reasonRequest)
    });
};
export const getActivateStaffUserMutationKey = () => ['activateStaffUser'];
export const getActivateStaffUserMutationOptions = (options) => {
    const mutationKey = getActivateStaffUserMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options ?
        options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
            options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey, }, request: undefined };
    const mutationFn = (props) => {
        const { userId, data } = props ?? {};
        return activateStaffUser(userId, data, requestOptions);
    };
    return { mutationFn, ...mutationOptions };
};
/**
* @summary Вернуть доступ сотруднику
*/
export const useActivateStaffUser = (options, queryClient) => {
    return useMutation(getActivateStaffUserMutationOptions(options), queryClient);
};
export const getListAuditLogUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/v1/staff/audit?${stringifiedParams}` : `/api/v1/staff/audit`;
};
/**
 * @summary Журнал аудита (со scope по точкам; записи без точки — при праве на все точки)
 */
export const listAuditLog = async (params, options) => {
    return apiFetch(getListAuditLogUrl(params), {
        ...options,
        method: 'GET'
    });
};
export const getListAuditLogQueryKey = (params) => {
    return [
        `/api/v1/staff/audit`, ...(params ? [params] : [])
    ];
};
export const getListAuditLogQueryOptions = (params, options) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getListAuditLogQueryKey(params);
    const queryFn = ({ signal }) => listAuditLog(params, { signal, ...requestOptions });
    return { queryKey, queryFn, ...queryOptions };
};
/**
 * @summary Журнал аудита (со scope по точкам; записи без точки — при праве на все точки)
 */
export function useListAuditLog(params, options, queryClient) {
    const queryOptions = getListAuditLogQueryOptions(params, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
//# sourceMappingURL=api.js.map